// import React, { Component } from 'react';
// import Cookies from 'universal-cookie';
// import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
// import Header from '../components/dashboardSubComponents/header'
// import SideBar from '../components/dashboardSubComponents/sideBarNav'
// import { Loader } from 'react-overlay-loader';
// import 'react-overlay-loader/styles.css';
// import SequenceTable from '../components/createQuestionSubComponents/sequenceTable'
// import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
// import {url,logout} from '../components/helper'
// import Pagination from "react-js-pagination";

// class CreateQuestionPageOne extends Component {

//     constructor(props) {
//         super(props)
//         this.state = {
//             "superuser":'',
//             "organization_admin":"",
//             "branch_admin":"",
//             "options_organization": [],
//             "options_branch": [],
//             "options_customers": [],
//             "options_sections": [],
//             "sequences": [],
//             "sequenceErrorMessageHidden":true,
//             "action_types": [{ value: 'Button', label: 'Button', id: 1 }],
//             "organization": null,
//             "branch": null,
//             "customer": "",
//             "section": null,
//             "action": null,
//             "action_text": "",
//             "btn_is_disabled": true,
//             "btn_s2_next_disabled": true,
//             "btn_next_s3_disabled": true,
//             "current_section": 5,
//             "loading": true,
//             "already_mounted": false,
//             "section_two_mounted": false,
//             "input_sequence": null,
//             "true_log": false,
//             "true_log_selected_type": null,
//             "true_log_list": [],
//             true_log_selected_option: null,
//             "true_log_text": null,
//             "true_log_date": false,
//             "true_log_GPS": false,
//             "true_log_package": false,
//             "true_log_driver_name": false,
//             "true_log_customer_name": false,
//             "true_block": false,
//             "true_block_text": null,
//             "true_status_list": [],
//             "true_status": false,
//             "true_selected_status": null,
//             "true_record": false,
//             "true_take_photo": false,
//             "true_take_signature": false,
//             "true_No_Action": false,
//             "false_log": false,
//             "false_log_selected_type": null,
//             "false_log_list": [],
//             false_log_selected_option: null,
//             "false_log_text": "",
//             "false_log_date": false,
//             "false_log_GPS": false,
//             "false_log_package": false,
//             "false_log_driver_name": false,
//             "false_log_customer_name": false,
//             "false_block": false,
//             "false_block_text": null,
//             "false_status_list": [],
//             "false_status": false,
//             "false_selected_status": null,
//             "false_record": false,
//             "false_take_photo": false,
//             "false_take_signature": false,
//             "false_No_Action": false,
//             "false_No_Action_disabled":false,
//             run_status_list:[],
//             drop_status_list:[],
//             status_type:[
//                 {"value":"Drop","label":"Drop", "id":0},{"label":"Run","value":"Run", "id":1}
//             ],
//             true_selected_status_type:null,
//             false_selected_status_type:null,
//             true_log_modal: false,
//             true_block_modal: false,
//             true_status_modal: false,
//             false_log_modal: false,
//             false_block_modal: false,
//             false_status_modal: false,
//             message_box_modal: false,
//             message_title: "",
//             msg_type: '',
//             message_body: "",
//             onClose_target_url: '',
//             true_log_disabled:false,
//             true_block_disabled:false,
//             true_status_disabled:false,
//             true_record_disabled:false,
//             true_take_photo_disabled:false,
//             true_take_signature_disabled:false,
//             true_No_Action_disabled:false,
//             false_log_disabled:false,
//             false_block_disabled:false,
//             false_status_disabled:false,
//             false_record_disabled:false,
//             false_take_photo_disabled:false,
//             false_take_signature_disabled:false,
//             activePage:1,
//             page_size:10,
//             recordSize:0

//         }

//         handleOrganizationSelect = handleOrganizationSelect.bind(this)
//         handleBranchSelect = handleBranchSelect.bind(this)
//         handleCustomerSelect = handleCustomerSelect.bind(this)
//         handleSectionSelect = handleSectionSelect.bind(this)
//         handleActionSelect = handleActionSelect.bind(this)
//         this.enable_btn = this.enable_btn.bind(this)
//         this.enable_next_s3_btn = this.enable_next_s3_btn.bind(this)
//         nextSectionTwo = nextSectionTwo.bind(this)
//         handleBtnNextS3Click = handleBtnNextS3Click.bind(this)
//         backToSectionTwo = backToSectionTwo.bind(this)
//         handleSequenceInput = handleSequenceInput.bind(this)
//         this.handle_question_text_input = this.handle_question_text_input.bind(this)
//         sectionTwoNextBtnHandle = sectionTwoNextBtnHandle.bind(this)
//         handleTrueLogCheckboxClick = handleTrueLogCheckboxClick.bind(this)
//         this.handleLogTypeSelect = this.handleLogTypeSelect.bind(this)
//         this.true_log_text_area = this.true_log_text_area.bind(this)
//         this.handle_true_log_date_checkbox_click = this.handle_true_log_date_checkbox_click.bind(this)
//         this.handle_true_log_GPS_checkbox_click = this.handle_true_log_GPS_checkbox_click.bind(this)
//         this.handle_true_log_package_checkbox_click = this.handle_true_log_package_checkbox_click.bind(this)
//         this.handle_true_log_driver_name_checkbox_click = this.handle_true_log_driver_name_checkbox_click.bind(this)
//         this.handle_true_log_customer_name_checkbox_click = this.handle_true_log_customer_name_checkbox_click.bind(this)
//         this.handle_true_block_checkbox_click = this.handle_true_block_checkbox_click.bind(this)
//         this.handle_true_record_checkbox_click = this.handle_true_record_checkbox_click.bind(this)
//         this.handle_true_status_status_checkbox_click = this.handle_true_status_status_checkbox_click.bind(this)
//         this.handleStatusSelect = this.handleStatusSelect.bind(this)
//         this.handle_true_take_photo_checkbox_click = this.handle_true_take_photo_checkbox_click.bind(this)
//         this.handle_true_take_signature_checkbox_click = this.handle_true_take_signature_checkbox_click.bind(this)
//         this.handle_true_No_Action_checkbox_click = this.handle_true_No_Action_checkbox_click.bind(this)
//         this.handle_block_text_input3 = this.handle_block_text_input3.bind(this)

//         this.handle_false_log_checkbox_click = this.handle_false_log_checkbox_click.bind(this)
//         this.FalsehandleLogTypeSelect = this.FalsehandleLogTypeSelect.bind(this)
//         this.false_log_text_area = this.false_log_text_area.bind(this)
//         this.handle_false_log_date_checkbox_click = this.handle_false_log_date_checkbox_click.bind(this)
//         this.handle_false_log_GPS_checkbox_click = this.handle_false_log_GPS_checkbox_click.bind(this)
//         this.handle_false_log_package_checkbox_click = this.handle_false_log_package_checkbox_click.bind(this)
//         this.handle_false_log_driver_name_checkbox_click = this.handle_false_log_driver_name_checkbox_click.bind(this)
//         this.handle_false_log_customer_name_checkbox_click = this.handle_false_log_customer_name_checkbox_click.bind(this)
//         this.handle_false_block_checkbox_click = this.handle_false_block_checkbox_click.bind(this)
//         this.handle_false_record_checkbox_click = this.handle_false_record_checkbox_click.bind(this)
//         this.handle_false_status_status_checkbox_click = this.handle_false_status_status_checkbox_click.bind(this)
//         this.FalsehandleStatusSelect = this.FalsehandleStatusSelect.bind(this)
//         this.handle_false_take_photo_checkbox_click = this.handle_false_take_photo_checkbox_click.bind(this)
//         this.handle_false_take_signature_checkbox_click = this.handle_false_take_signature_checkbox_click.bind(this)
//         this.handle_false_No_Action_checkbox_click = this.handle_false_No_Action_checkbox_click.bind(this)
//         backSection3Btn = backSection3Btn.bind(this)
//         this.section_three_next_btn_handle = this.section_three_next_btn_handle.bind(this)
//         this.back_section_4_btn = this.back_section_4_btn.bind(this)
//         this.create_question = this.create_question.bind(this)
//         this.handle_false_block_text_input = this.handle_false_block_text_input.bind(this)
//         this.back_section_5_btn = this.back_section_5_btn.bind(this)
//         this.handle_true_log_text_input = this.handle_true_log_text_input.bind(this)
//         this.handle_false_log_text_input = this.handle_false_log_text_input.bind(this)
//         this.toggle_true_log_modal = this.toggle_true_log_modal.bind(this)
//         this.toggle_true_block_modal = this.toggle_true_block_modal.bind(this)
//         this.toggle_true_status_modal = this.toggle_true_status_modal.bind(this)
//         this.toggle_false_log_modal = this.toggle_false_log_modal.bind(this)
//         this.toggle_false_block_modal = this.toggle_false_block_modal.bind(this)
//         this.toggle_false_status_modal = this.toggle_false_status_modal.bind(this)
//         closeMessageBoxModal = closeMessageBoxModal.bind(this)
//         this.reset_state = this.reset_state.bind(this)
//         this.close_on_success = this.close_on_success.bind(this)
//         this.handleStatusTypeSelect = this.handleStatusTypeSelect.bind(this)
//         this.handleFalseStatusTypeSelect = this.handleFalseStatusTypeSelect.bind(this)
//         this.FalsehandleStatusTypeSelect = this.FalsehandleStatusTypeSelect.bind(this)
//         fetchWizardSequence = fetchWizardSequence.bind(this)

//     }

//     reset_state = () => {
//         this.setState(
//             {
//                 "options_branch": [],
//                 "sequences": [],
//                 "organization": null,
//                 "branch": null,
//                 "customer": "",
//                 "section": null,
//                 "action": null,
//                 "action_text": "",
//                 "btn_is_disabled": true,
//                 "btn_s2_next_disabled": true,
//                 "btn_next_s3_disabled": true,
//                 "current_section": 1,
//                 "loading": false,
//                 "already_mounted": false,
//                 "section_two_mounted": false,
//                 "input_sequence": null,

//                 "true_log": false,
//                 "true_log_selected_type": null,
//                 true_log_selected_option: null,
//                 "true_log_text": null,
//                 "true_log_date": false,
//                 "true_log_GPS": false,
//                 "true_log_package": false,
//                 "true_log_driver_name": false,
//                 "true_log_customer_name": false,

//                 "true_block": false,
//                 "true_block_text": null,

//                 "true_status": false,
//                 "true_selected_status": null,
//                 "true_record": false,
//                 "true_take_photo": false,
//                 "true_take_signature": false,
//                 "true_No_Action": false,

//                 "false_log": false,
//                 "false_log_selected_type": null,
//                 false_log_selected_option: null,
//                 "false_log_text": "",
//                 "false_log_date": false,
//                 "false_log_GPS": false,
//                 "false_log_package": false,
//                 "false_log_driver_name": false,
//                 "false_log_customer_name": false,

//                 "false_block": false,
//                 "false_block_text": null,

//                 "false_status": false,
//                 "false_selected_status": null,
//                 "false_record": false,
//                 "false_take_photo": false,
//                 "false_take_signature": false,
//                 "false_No_Action": false,

//                 true_log_modal: false,
//                 true_block_modal: false,
//                 true_status_modal: false,

//                 false_log_modal: false,
//                 false_block_modal: false,
//                 false_status_modal: false,

//                 message_box_modal: false,
//                 message_title: "",
//                 message_body: "",
//                 onClose_target_url: ''
//             }
//         )
//     }

//     toggle_true_log_modal = () => {
//         this.setState({
//             true_log_modal: !this.state.true_log_modal
//         });
//     }

//     toggle_true_block_modal = () => {
//         this.setState({
//             true_block_modal: !this.state.true_block_modal
//         })
//     }

//     toggle_true_status_modal = () => {
//         this.setState({
//             true_status_modal: !this.state.true_status_modal
//         })
//     }

//     toggle_false_log_modal = () => {
//         this.setState({
//             false_log_modal: !this.state.false_log_modal
//         })
//     }

//     toggle_false_block_modal = () => {
//         this.setState({
//             false_block_modal: !this.state.false_block_modal
//         })
//     }

//     toggle_false_status_modal = () => {
//         this.setState({
//             false_status_modal: !this.state.false_status_modal
//         })
//     }

//     close_on_success = () => {
//         this.setState({
//             message_box_modal: !messageBoxModal
//         })
//         if(branch_admin === 'true'){
//             //("true before resetting state")
//             var temp = optionsBranch
//             this.reset_state()
//             this.setState({options_branch:temp})

//         }
//         else{
//             this.reset_state()
//         }

//     }
//     close_message_box_modal = () => {

//         this.setState({
//             message_box_modal: !messageBoxModal,
//             loading: false
//         })
//         console.log("&&&&&&&&&&&&&&&&&&&&&")
//         console.log(this.state.msg_type)
//         console.log(this.state.msg_type )
//         if (this.state.msg_type === 'success' & this.state.msg_type !=='') {
//             if(branch_admin === 'true'){
//                 //("true before resetting state")
//                 var temp = optionsBranch
//                 this.reset_state()
//                 this.setState({options_branch:temp,organization:{ value: 'all', label: 'all', id: -1}})
//             }
//             else{
//                 this.reset_state()
//             }
//         }
//     }

//     componentWillMount = () => {
//         const cookies = new Cookies();
//         var superuser = cookies.get('superuser')
//             var organization_admin = cookies.get('organization-admin')
//             var branch_admin = cookies.get('branch-admin')
//             var http = new XMLHttpRequest();
//         if(cookies.get('branch-user') === "true"){
//             window.location = '/dashboard'
//         }
//         if (this.state.already_mounted === false) {

//             var loginStatus = cookies.get('loggedIn')
//             //(loginStatus)
//             if (loginStatus === undefined) {
//                 window.location = '/login'
//             } else {
//                 this.setState({ current_section: 1,
//                     superuser:superuser,
//                     organization_admin:organization_admin,
//                     branch_admin:branch_admin })
//             }

//             var dashboar_ref = this
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             //(url+'/api/questions/wizard/organisation?user_id=' + user_id)
//             //('Token ' + token)
//             if(branch_admin === 'true'){
//                 http.open('GET', url+'/api/questions/wizard/branch?user_id=' + user_id, true);
//             }
//             else{
//                 http.open('GET', url+'/api/questions/wizard/organisation?user_id=' + user_id, true);
//             }
//             http.setRequestHeader("Authorization", "Bearer " + token);

//             http.send()
//             // http.setRequestHeader('Authorization','Token '+token)
//             http.onreadystatechange = function () {
//                 //(http.responseText)
//                 if (http.readyState === 4 && http.status === 200) {
//                     var json = JSON.parse(http.responseText)
//                         if (json.status === 200) {
//                             if(dashboar_ref.state.branch_admin === 'true'){
//                                 //(" B admin")
//                             var branches = []
//                             // var branches = []
//                             var customer = []
//                             // var section = []
//                             var types = []
//                             // var log_types = []
//                             // var drop_status_codes = []
//                             // var run_status_codes = []
//                             //(json.branches)
//                         json.branches.forEach(element => {
//                             var temp = {
//                                 value: element.branch_name, label: element.branch_name, id: element.branch_id
//                             }
//                             branches.push(temp)
//                             //(branches)
//                         });
//                         //('braches lenght '+branches.length)
//                         var len = branches.length
//                         if(len > 1){
//                             branches.unshift({
//                                 value: 'all', label: 'all', id: 0
//                             })
//                         }

//                             json.question_types.forEach(element => {
//                                 var temp = {
//                                     value: element.question_type, label: element.question_type, id: element.question_type_id
//                                 }
//                                 types.push(temp)
//                                 //(types)
//                             });
//                             // json.drop_statuses.forEach(element =>{
//                             //     var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                             //     drop_status_codes.push(temp)
//                             // })
//                             // json.run_statuses.forEach(element =>{
//                             //     var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                             //     run_status_codes.push(temp)
//                             // })
//                             // json.question_sections.forEach(element => {
//                             //     var temp = {
//                             //         value: element.question_section_type, label: element.question_section_type, id: element.question_section_id
//                             //     }
//                             //     section.push(temp)
//                             //     //(section)
//                             // });
//                             // json.question_log_types.forEach(element =>{
//                             //     var temp = { value: element.log_type, label: element.log_type, id: element.log_type_id }
//                             //     log_types.push(temp)
//                             // })

//                             customer.unshift({
//                                 value: 'all', label: 'all', id: 0
//                             })

//                             dashboar_ref.setState({
//                                 organization:{ value: 'all', label: 'all', id: -1},
//                                 action_types: types,
//                                 // options_sections: section,
//                                 loading: false,
//                                 already_mounted: true,
//                                 options_branch:branches,
//                                 // run_status_list:run_status_codes,
//                                 // drop_status_list:drop_status_codes,
//                                 // true_log_list:log_types,
//                                 // false_log_list:log_types

//                             })
//                             }
//                             else{
//                                 var orgs = []
//                             // var branches = []
//                             var customer = []
//                             // var section = []
//                             var types = []
//                             // var log_types = []
//                             // var drop_status_codes = []
//                             // var run_status_codes = []

//                                 json.organisations.forEach(element => {
//                                     var temp = {
//                                         value: element.org_name, label: element.org_name, id: element.org_id
//                                     }
//                                     orgs.push(temp)
//                                     //(orgs)
//                                 });

//                             json.question_types.forEach(element => {
//                                 var temp = {
//                                     value: element.question_type, label: element.question_type, id: element.question_type_id
//                                 }
//                                 types.push(temp)
//                                 //(types)
//                             });

//                             // json.drop_statuses.forEach(element =>{
//                             //     var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                             //     drop_status_codes.push(temp)
//                             // })
//                             // json.run_statuses.forEach(element =>{
//                             //     var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                             //     run_status_codes.push(temp)
//                             // })
//                             // json.question_sections.forEach(element => {
//                             //     var temp = {
//                             //         value: element.question_section_type, label: element.question_section_type, id: element.question_section_id
//                             //     }
//                             //     section.push(temp)
//                             //     //(section)
//                             // });
//                             // json.question_log_types.forEach(element =>{
//                             //     var temp = { value: element.log_type, label: element.log_type, id: element.log_type_id }
//                             //     log_types.push(temp)
//                             // })
//                            if(orgs.length > 1){
//                             orgs.unshift({
//                                 value: 'all', label: 'all', id: 0
//                             })
//                            }

//                             customer.unshift({
//                                 value: 'all', label: 'all', id: 0
//                             })

//                             dashboar_ref.setState({
//                                 options_organization: orgs,
//                                 action_types: types,
//                                 // options_branch:branches,
//                                 options_customers: customer,
//                                 // options_sections: section,
//                                 loading: false,
//                                 already_mounted: true,
//                                 // run_status_list:run_status_codes,
//                                 // drop_status_list:drop_status_codes,
//                                 // true_log_list:log_types,
//                                 // false_log_list:log_types

//                             })
//                             }
//                         }
//                         else{
//                             dashboar_ref.setState({
//                                 message_title:"Connection Error",
//                                 message_body:"could not contact server. Please try again by refreshing page out else",
//                                 message_box_modal:true
//                             })
//                         }
//                 }
//                 if(http.readyState === 4 && http.status === 401){
//                     logout()
//                 }

//             }
//             http.onerror = function (){
//                 dashboar_ref.setState({
//                     message_box_modal:true,
//                     message_title:"Could not load data",
//                     message_body:"Server did not respond in time. Try refreshing page or contact your service provider"
//                  })
//             }
//         }

//     }

//     handleOrganizationSelect = (organization) => {
//         this.setState({ organization, loading: true }, this.enable_btn);
//         if (organization.id !== 0) {
//             this.setState({branch:null})
//             this.setState({ organization, loading: true }, this.enable_btn);
//             const cookies = new Cookies();
//             var http = new XMLHttpRequest();
//             var dashboar_ref = this
//             var user_id = cookies.get('user_id')
//             var token = cookies.get('token')
//             //('Token ' + token)
//             http.open('GET', url+'/api/questions/wizard/branch?user_id=' + user_id + '&org_id=' + organization.id, true);
//             http.setRequestHeader("Authorization", "Bearer " + token);
//             http.send()
//             http.onreadystatechange = function () {
//                 //(http.responseText)
//                 if (http.readyState === 4 && http.status === 200) {
//                     var json = JSON.parse(http.responseText)
//                     if (json.status === 200) {
//                         var branches = []
//                         json.branches.forEach(element => {
//                             var temp = {
//                                 value: element.branch_name, label: element.branch_name, id: element.branch_id
//                             }
//                             branches.push(temp)
//                             //(branches)
//                         });
//                         if(branches.length>=2){
//                             branches.unshift({
//                                 value: 'all', label: 'all', id: 0
//                             })
//                         }
//                         dashboar_ref.setState({
//                             options_branch: branches,
//                             loading: false
//                         })
//                     }
//                     else{
//                         dashboar_ref.setState({
//                             message_title:"Connection Error",
//                             message_body:"could not contact server. Please try again by refreshing page",
//                             message_box_modal:true
//                         })
//                     }
//                 }
//             }
//             http.onerror = function (){
//                 dashboar_ref.setState({
//                     message_box_modal:true,
//                     message_title:"Could not load data",
//                     message_body:"Server did not respond in time. Try refreshing page or contact your service provider"
//                  })
//             }

//             //(`Option selected:`, organization.id);
//         }
//         else {
//             var branches = []
//             branches.push({
//                 value: 'all', label: 'all', id: 0
//             })
//             this.setState({
//                 options_branch: branches,
//                 branch: { value: 'all', label: 'all', id: 0 },
//                 loading: false
//             })
//             handleBranchSelect({ value: 'all', label: 'all', id: 0 })
//         }

//     }

//     handleBranchSelectSelect = (branch) => {
//         this.setState({ branch }, this.enable_btn);
//         var org_id = 0
//         if(organization != null){
//             org_id = organization.id
//         }
//         var id = branch.id
//         this.setState({loading:true})
//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //('Token ' + token)
//         http.open('GET', url+'/api/questions/wizard/runsheet?user_id='+ user_id+'&org_id='+org_id+'&branch_id='+id, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.send()
//         http.onreadystatechange = function(){
//             if(http.readyState === 4 && http.status === 200){
//                 var json = JSON.parse(http.responseText)
//                 console.log(json)
//                 if(json.status === 200){
//                     var section = []
//                     var log_types = []
//                     var drop_status_codes = []
//                     var run_status_codes = []

//                     json.drop_statuses.forEach(element =>{
//                         var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                         drop_status_codes.push(temp)
//                     })
//                     json.run_statuses.forEach(element =>{
//                         var temp ={ value: element.status_name, label: element.status_name, id: element.status_id}
//                         run_status_codes.push(temp)
//                     })
//                     json.question_sections.forEach(element => {
//                         var temp = {
//                             value: element.question_section_type, label: element.question_section_type, id: element.question_section_id
//                         }
//                         section.push(temp)
//                         //(section)
//                     });
//                     json.question_log_types.forEach(element =>{
//                         var temp = { value: element.log_type, label: element.log_type, id: element.log_type_id }
//                         log_types.push(temp)
//                     })

//                     dashboar_ref.setState({
//                         loading: false,
//                         // sequences: json.sequences,
//                         options_sections: section,
//                         already_mounted: true,
//                         run_status_list:run_status_codes,
//                         drop_status_list:drop_status_codes,
//                         true_log_list:log_types,
//                         false_log_list:log_types
//                     })
//                 }
//                 else{
//                     dashboar_ref.setState({
//                         loading:false
//                     })
//                 }
//             }
//         }
//     }

//     handleCustomerSelect = () => {
//         var input = document.getElementById("cust_code").value
//         if(input !== ""){
//             this.setState({ customer:input });
//         }

//     }
//     handleSectionSelect = (section) => {
//         this.setState({ section }, this.enable_btn);
//     }

//     handleActionSelect = (action) => {
//         this.setState({ action,
//             true_No_Action:false,
//                 false_No_Action:false
//          }, this.enable_next_s3_btn)

//         this.setState({
//             true_log:false,
//             true_block:false,
//             true_status:false,
//             true_record:false,
//             true_take_photo:false,
//             true_take_signature:false,
//             true_No_Action:false,
//             false_log:false,
//             false_block:false,
//             false_status:false,
//             false_record:false,
//             false_take_photo:false,
//             false_take_signature:false,
//             false_No_Action:false,
//         })
//         if(action.label === 'text'){
//             this.setState({
//                 false_No_Action:true,
//                 true_No_Action:true,
//             })
//         }
//         if(action.label === 'page'){
//             this.setState({
//                 true_No_Action:true,
//                 false_No_Action:true,
//                 true_log_disabled:true,
//                 true_block_disabled:true,
//                 true_status_disabled:true,
//                 true_record_disabled:true,
//                 true_take_photo_disabled:true,
//                 true_take_signature_disabled:true,
//                 true_No_Action_disabled:true,
//                 false_log_disabled:true,
//                 false_block_disabled:true,
//                 false_status_disabled:true,
//                 false_record_disabled:true,
//                 false_take_photo_disabled:true,
//                 false_take_signature_disabled:true,
//                 false_No_Action_disabled:true
//             })
//         }
//         if(action.label === 'log'){
//             this.setState({
//                 false_No_Action:true,
//             })
//         }

//         if(action.label === 'status'){
//             this.setState({
//                 true_status:true,
//                 false_No_Action:true,
//             })
//         }
//     }

//     enable_btn = () => {
//         // alert(organization)
//         if (organization != null & branch != null & section != null) {
//             this.setState({
//                 "btn_is_disabled": false
//             })
//         }
//     }

//     next_section_two = () => {
//         this.setState({
//             current_section: 5,
//             loading: true
//         })
//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //('Token ' + token)
//         var base_url = url+'/api/questions/wizard/sequence?user_id=' + user_id
//         if (organization.id !== 0) {
//             base_url = base_url + '' + '&org_id=' + organization.id
//         }
//         if (branch.id !== 0) {
//             base_url = base_url + '' + '&branch_id=' + branch.id
//         }
//         base_url = base_url + '' + '&customer_code=' + this.state.customer
//         base_url = base_url + '&section_id=' + section.id + '&page=1'
//         console.log(base_url)
//         http.open('GET', base_url, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.send()
//         //(http.response)
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 //(http.responseText)
//                 if (json.status === 200) {

//                     dashboar_ref.setState({
//                         loading: false,
//                         current_section:2,
//                         sequences: json.sequences,
//                         recordSize:json.total_questions,
//                         activePage:1
//                     })
//                 }
//                 else {

//                         dashboar_ref.setState({
//                             message_title:"Connection Error",
//                             message_body:"could not contact server. Please try again by refreshing page out else",
//                             message_box_modal:true,
//                             loading: false
//                         })

//                 }
//             }

//         }
//         http.ontimeout = () =>{
//             dashboar_ref.setState({
//                 message_title:"Connection Error",
//                 message_body:"could not contact server. Please try again by refreshing page out else",
//                 message_box_modal:true,
//                 loading:false,
//                 sequences:[]
//             })
//         }
//         http.onerror = () =>{
//             dashboar_ref.setState({
//                 message_title:"Connection Error",
//                 message_body:"could not contact server. Please try again by refreshing page out else",
//                 message_box_modal:true,
//                 loading:false,
//                 sequences:[]
//             })
//         }

//     }

//     fetch(page){
//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var dashboar_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //('Token ' + token)
//         var base_url = url+'/api/questions/wizard/sequence?user_id=' + user_id
//         if (organization.id !== 0) {
//             base_url = base_url + '' + '&org_id=' + organization.id
//         }
//         if (branch.id !== 0) {
//             base_url = base_url + '' + '&branch_id=' + branch.id
//         }
//         base_url = base_url + '' + '&customer_code=' + this.state.customer
//         base_url = base_url + '&section_id=' + section.id
//         base_url = base_url + '&page='+page
//         //(base_url)
//         http.open('GET', base_url, true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.send()
//         //(http.response)
//         http.onreadystatechange = function () {
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 //(http.responseText)
//                 if (json.status === 200) {

//                     dashboar_ref.setState({
//                         loading: false,
//                         sequences: json.sequences,
//                         recordSize:json.total_questions,
//                         activePage:page
//                     })
//                 }
//                 else {

//                         dashboar_ref.setState({
//                             message_title:"Connection Error",
//                             message_body:"could not contact server. Please try again by refreshing page out else",
//                             message_box_modal:true,
//                             loading: false
//                         })

//                 }
//             }

//         }
//         http.ontimeout = () =>{
//             dashboar_ref.setState({
//                 message_title:"Connection Error",
//                 message_body:"could not contact server. Please try again by refreshing page out else",
//                 message_box_modal:true,
//                 activePage:dashboar_ref.state.activePage
//             })
//         }
//         http.onerror = () =>{
//             dashboar_ref.setState({
//                 message_title:"Connection Error",
//                 message_body:"could not contact server. Please try again by refreshing page out else",
//                 message_box_modal:true,
//                 activePage:dashboar_ref.state.activePage
//             })
//         }
//     }

//     handleSequenceInput = () => {
//         var input_sequence_local = document.getElementById('sequence_input').value
//         //(input_sequence_local)
//         var isNotDecimal = (parseFloat(input_sequence_local) - Math.floor(parseFloat(input_sequence_local))) !== 0;
//         //("is decimal "+isNotDecimal)
//         if (input_sequence_local > 0 & input_sequence_local < 100 & !isNotDecimal) {
//             this.setState({
//                 btn_s2_next_disabled: false,
//                 input_sequence: input_sequence_local,
//                 sequenceErrorMessageHidden:true
//             })
//         }
//         else {
//             this.setState({
//                 btn_s2_next_disabled: true,
//                 input_sequence: input_sequence_local,
//                 sequenceErrorMessageHidden:false
//             })
//         }
//     }

//     back_to_section_two = () => {
//         this.setState({
//             current_section: 1
//         })
//     }

//     section_two_next_btn_handle = () => {
//         this.setState({
//             current_section: 3
//         })
//     }

//     //Section III Handles

//     handle_true_log_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" ){
//             return
//         }

//         if (this.state.true_No_Action === false) {
//             var current_state = this.state.true_log
//             var modal = current_state === true ? false : true
//             this.setState({
//                 true_log: !current_state,
//                 true_log_modal: modal
//             })
//         }
//     }

//     handleLogTypeSelect = (true_log_selected_type) => {

//         this.setState({ true_log_selected_type });

//         //(`Option selected:`, true_log_selected_type);
//     }

//     true_log_text_area = () => {
//         var value = document.getElementById('true_log_text').value
//         //("called " + value)
//         this.setState({
//             true_log_text: value
//         })
//     }

//     handle_true_log_date_checkbox_click = () => {
//         var current = this.state.true_log_date
//         this.setState({
//             true_log_date: !current
//         })
//     }

//     handle_true_log_GPS_checkbox_click = () => {
//         var current = this.state.true_log_GPS
//         this.setState({
//             true_log_GPS: !current
//         })
//     }

//     handle_true_log_package_checkbox_click = () => {
//         var current = this.state.true_log_package
//         this.setState({
//             true_log_package: !current
//         })
//     }

//     handle_true_log_driver_name_checkbox_click = () => {
//         var current = this.state.true_log_driver_name
//         this.setState({
//             true_log_driver_name: !current
//         })
//     }

//     handle_true_log_customer_name_checkbox_click = () => {
//         var current = this.state.true_log_customer_name
//         this.setState({
//             true_log_customer_name: !current
//         })
//     }

//     handle_true_block_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" || this.state.action.label === "button"){
//             return
//         }
//         if (this.state.true_No_Action === false) {
//             var current = this.state.true_block
//             var modal = current === true ? false : true
//             this.setState({
//                 true_block: !current,
//                 true_block_modal: modal
//             })
//         }
//         if(!current === true){
//             this.setState({
//                 // true_log:false,
//                 // true_status:false,
//                 // true_record:false,
//                 true_take_photo:false,
//                 true_take_signature:false,
//                 true_No_Action:false
//             })
//         }
//     }

//     handle_true_record_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" ){
//             return
//         }
//         if (this.state.true_No_Action === false) {
//             var current = this.state.true_record
//             this.setState({
//                 true_record: !current
//             })
//         }
//     }

//     handle_true_status_status_checkbox_click = () => {
//         if(this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" ){
//             return
//         }
//         if (this.state.true_No_Action === false) {
//             var current = this.state.true_status
//             var modal = current === true ? false : true
//             this.setState({
//                 true_status: !current,
//                 true_status_modal: modal
//             })
//         }
//     }

//     handleStatusSelect = (true_selected_status) => {
//         this.setState({ true_selected_status })
//     }

//     handleStatusTypeSelect = (true_selected_status_type) =>{
//         // true_status_list
//         var list = []
//         if(true_selected_status_type.id === 0){
//             list= this.state.drop_status_list
//         }
//         else{
//             list=this.state.run_status_list
//         }
//         this.setState({true_selected_status_type})
//         this.setState({
//             true_status_list:list
//         })
//     }

//     handleFalseStatusTypeSelect = (false_selected_status_type) =>{

//         this.setState({false_selected_status_type})
//     }

//     handle_true_take_photo_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" || this.state.true_block === true ){
//             return
//         }
//         if (this.state.true_No_Action === false) {
//             var current = this.state.true_take_photo
//             this.setState({
//                 true_take_photo: !current,
//                 true_take_signature:false
//             })
//         }
//     }

//     handle_true_take_signature_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" || this.state.true_block === true  ){
//             return
//         }
//         if (this.state.true_No_Action === false) {
//             var current = this.state.true_take_signature
//             this.setState({
//                 true_take_signature: !current,
//                 true_take_photo:false
//             })
//         }
//     }

//     handle_true_No_Action_checkbox_click = () => {
//         var current = this.state.true_No_Action
//         this.setState({
//             true_log: false,
//             true_block: false,
//             true_status: false,
//             true_record: false,
//             true_take_photo: false,
//             true_take_signature: false,
//             true_No_Action: !current
//         })
//     }

//     handle_question_text_input = () => {
//         var input = document.getElementById('q_text_input').value
//         this.setState({
//             action_text: input
//         }, this.enable_next_s3_btn)
//         //(input)
//     }

//     enable_next_s3_btn = () => {
//         if (this.state.action !== null &&   actionText !== "") {

//             this.setState({
//                 btn_next_s3_disabled: false
//             })
//         }
//         else {
//             this.setState({
//                 btn_next_s3_disabled: true
//             })
//         }
//     }

//     handle_btn_next_s3_click = () => {
//         this.setState({
//             current_section: 4
//         })
//     }

//     // section 4 handles

//     handle_false_log_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" ){
//             return
//         }
//         if (this.state.false_No_Action === false) {
//             var current_state = this.state.false_log
//             var modal = current_state === true ? false : true
//             this.setState({
//                 false_log: !current_state,
//                 false_log_modal: modal
//             })
//         }
//     }

//     FalsehandleLogTypeSelect = (false_log_selected_type) => {
//         this.setState({ false_log_selected_type });

//         //(`Option selected:`, false_log_selected_type);
//     }

//     false_log_text_area = () => {
//         var value = document.getElementById('false_log_text').value
//         //("called " + value)
//         this.setState({
//             false_log_text: value
//         })
//     }

//     handle_false_log_date_checkbox_click = () => {
//         var current = this.state.false_log_date
//         this.setState({
//             false_log_date: !current
//         })
//     }

//     handle_false_log_GPS_checkbox_click = () => {
//         var current = this.state.false_log_GPS
//         this.setState({
//             false_log_GPS: !current
//         })
//     }

//     handle_false_log_package_checkbox_click = () => {

//         var current = this.state.false_log_package
//         this.setState({
//             false_log_package: !current
//         })
//     }

//     handle_false_log_driver_name_checkbox_click = () => {
//         var current = this.state.false_log_driver_name
//         this.setState({
//             false_log_driver_name: !current
//         })
//     }

//     handle_false_log_customer_name_checkbox_click = () => {
//         var current = this.state.false_log_customer_name
//         this.setState({
//             false_log_customer_name: !current
//         })
//     }

//     handle_false_block_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log"){
//             return
//         }

//         if (this.state.false_No_Action === false) {
//             var current = this.state.false_block
//             var modal = current === true ? false : true
//             this.setState({
//                 false_block: !current,
//                 false_block_modal: modal
//             })

//         }

//         if(!current === true){
//             this.setState({
//                 false_take_photo:false,
//                 false_take_signature:false,
//                 false_No_Action:false
//             })
//         }
//     }

//     handle_false_record_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" ){
//             return
//         }
//         if (this.state.false_No_Action === false) {
//             var current = this.state.false_record
//             this.setState({
//                 false_record: !current
//             })
//         }
//     }

//     handle_false_status_status_checkbox_click = () => {
//         if(this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" ){
//             return
//         }
//         if (this.state.false_No_Action === false) {
//             var current = this.state.false_status
//             var modal = current === true ? false : true
//             this.setState({
//                 false_status: !current,
//                 false_status_modal: modal
//             })
//         }
//     }

//     FalsehandleStatusTypeSelect = (false_selected_status_type) =>{

//         var list = []
//         if(false_selected_status_type.id === 0){
//             list= this.state.drop_status_list
//         }
//         else{
//             list=this.state.run_status_list
//         }
//         //(list)
//         this.setState({false_selected_status_type})
//         this.setState({
//             false_status_list:list
//         })
//     }

//     FalsehandleStatusSelect = (false_selected_status) => {
//         this.setState({ false_selected_status })
//     }

//     handle_false_take_photo_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" || this.state.false_block === true || this.state.action.label === "button"){
//             return
//         }
//         if (this.state.false_No_Action === false) {
//             var current = this.state.false_take_photo
//             this.setState({
//                 false_take_photo: !current,
//                 false_take_signature:false
//             })
//         }
//     }

//     handle_false_take_signature_checkbox_click = () => {
//         if(this.state.action.label === "status" || this.state.action.label === "text" || this.state.action.label === "page" || this.state.action.label === "log" || this.state.false_block === true || this.state.action.label === "button"){
//             return
//         }
//         if (this.state.false_No_Action === false) {
//             var current = this.state.false_take_signature
//             this.setState({
//                 false_take_signature: !current,
//                 false_take_photo:false
//             })
//         }
//     }

//     handle_true_log_text_input = () => {
//         var input = document.getElementById('t_log_text').value
//         this.setState({
//             true_log_text: input
//         })
//     }

//     handle_false_log_text_input = () => {
//         var input = document.getElementById('f_log_text').value
//         this.setState({
//             false_log_text: input
//         })
//     }

//     handle_false_No_Action_checkbox_click = () => {
//         //(actionText.label)
//         if(this.state.action.label === 'text'){
//             //("should have returned "+actionText.label)
//             return
//         }
//         var current = this.state.false_No_Action
//         this.setState({
//             false_log: false,
//             false_block: false,
//             false_status: false,
//             false_record: false,
//             false_take_photo: false,
//             false_take_signature: false,
//             false_No_Action: !current
//         })
//     }
//     handle_block_text_input3 = () => {
//         var input = document.getElementById('block_text_input').value
//         this.setState({ true_block_text: input })
//     }

//     section_three_next_btn_handle = () => {
//         if (this.state.true_log === false & this.state.true_block === false & this.state.true_status === false & this.state.true_record === false
//             & this.state.true_take_photo === false & this.state.true_take_signature === false & this.state.true_No_Action === false) {
//             alert("No False Actions have been specified kindly specify atleast one action or check 'No Action' to continue")
//             return
//         }
//         if (this.state.true_log === true & this.state.true_log_selected_type === null) {
//             alert("You have checked log option. Please also select type of log")
//             return
//         }

//         if (this.state.true_block === true & this.state.true_block_text === null) {
//             alert("You have checked block option. Please also Enter block text")
//             return
//         }
//         if (this.state.true_status === true & this.state.true_selected_status === null) {
//             alert("You have checked Status option. Please also select status code")
//             return
//         }
//         else {
//             //(this.state.true_log_text)
//             //(this.state.false_log_text)
//             this.setState(
//                 { current_section: 5 }
//             )
//         }
//     }

//     back_section_3_btn = () => {
//         // //(inputSequence)
//         // document.getElementById('sequence_input').value=inputSequence

//         this.setState({ current_section: 2 })
//     }
//     back_section_4_btn = () => {
//         this.setState({ current_section: 3 })
//     }

//     back_section_5_btn = () => {
//         this.setState({ current_section: 4 })
//     }

//     create_question = () => {
//         //(this.state.msg_type)
//         this.setState({ loading: true })
//         if (this.state.true_log === false & this.state.true_block === false & this.state.true_status === false & this.state.true_record === false
//             & this.state.true_take_photo === false & this.state.true_take_signature === false & this.state.true_No_Action === false) {
//             this.setState({
//                 message_title: "No True Action Specified",
//                 message_body: "No True Actions have been specified kindly specify atleast one action or check 'No Action' to continue",
//                 message_box_modal: true
//             })
//             return
//         }
//         if (this.state.true_log === true & this.state.true_log_selected_type === null) {

//             this.setState({
//                 message_title: "Type of log unselected",
//                 message_body: "You have checked log option for True action. Please also select type of log",
//                 message_box_modal: true
//             })
//             return
//         }

//         if (this.state.true_block === true & this.state.true_block_text === null) {
//             this.setState({
//                 message_title: "No Block Text",
//                 message_body: "You have checked block option for true action. Please also Enter block text",
//                 message_box_modal: true
//             })
//             return
//         }
//         if (this.state.true_status === true & this.state.true_selected_status === null) {

//             this.setState({
//                 message_title: "No Status Code",
//                 message_body: "You have checked status option for true action. Please also select status code",
//                 message_box_modal: true
//             })

//             return
//         }
//         if (this.state.false_log === false & this.state.false_block === false & this.state.false_status === false & this.state.false_record === false
//             & this.state.false_take_photo === false & this.state.false_take_signature === false & this.state.false_No_Action === false) {

//             this.setState({
//                 message_title: "No False Action Specified",
//                 message_body: "No False Actions have been specified kindly specify atleast one action or check 'No Action' to continue",
//                 message_box_modal: true
//             })
//             return
//         }
//         if (this.state.false_log === true & this.state.false_log_selected_type === null) {

//             this.setState({
//                 message_title: "No Log Type Selected",
//                 message_body: "You have checked log option for false action. Please also select type of log",
//                 message_box_modal: true
//             })
//             return
//         }

//         if (this.state.false_block === true & this.state.false_block_text === null) {

//             this.setState({
//                 message_title: "No Block Text",
//                 message_body: "You have checked block option for false action. Please also Enter block text",
//                 message_box_modal: true
//             })
//             return
//         }
//         if (this.state.false_status === true & this.state.false_selected_status === null) {
//             this.setState({
//                 message_title: "No Status Code Selected",
//                 message_body: "You have checked status option for false action. Please also select status code",
//                 message_box_modal: true
//             })
//             return
//         }

//         if(this.state.true_block === true && this.state.false_block === true){
//             this.setState({
//                 message_title: "Multiple Block options specified",
//                 message_body: "You have checked Block option for both true andd false actions. You can not select block option for both actions",
//                 message_box_modal: true
//             })
//             return
//         }

//         var arg_list = '&org_id=' + organization.id + '&branch_id=' + branch.id + '&section_id=' + section.id + '&sequence=' + inputSequence + '&true_log=' + this.state.true_log + '&customer_code=' + this.state.customer + '&question_type=' + this.state.action.id + '&question_text=' + actionText + '&false_log=' + this.state.false_log
//         arg_list = this.state.true_log ? arg_list + '&true_log_type_id=' + this.state.true_log_selected_type.id : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_GPS=' + this.state.true_log_GPS : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_text=' + this.state.true_log_text : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_no_packages=' + this.state.true_log_package : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_dateTime=' + this.state.true_log_date : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_driver_name=' + this.state.true_log_driver_name : arg_list
//         arg_list = this.state.true_log ? arg_list + '&true_log_customer_name=' + this.state.true_log_customer_name : arg_list
//         //apend true block option selection
//         arg_list = arg_list + '&true_block=' + this.state.true_block
//         arg_list = this.state.true_block ? arg_list + '&true_block_text=' + this.state.true_block_text : arg_list
//         // true status option

//         arg_list = arg_list + '&true_status=' + this.state.true_status
//         //(typeof this.state.true_status)
//         if(this.state.true_status){
//             //("&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&")
//             //(this.state.true_selected_status)
//             arg_list = this.state.true_status ? arg_list + '&true_status_id=' + this.state.true_selected_status.id : arg_list
//         arg_list = this.state.true_selected_status_type.id === 0 ? arg_list + '&true_drop_status=true&true_run_status=false' :arg_list +  '&true_drop_status=false&true_run_status=true'
//         }

//         //append true record option
//         arg_list = arg_list + '&true_record=' + this.state.true_record
//         //append true take photo
//         arg_list = arg_list + '&true_take_photo=' + this.state.true_take_photo
//         //append true take signature option
//         arg_list = arg_list + '&true_take_signature=' + this.state.true_take_signature
//         // append no action option
//         arg_list = this.state.true_No_Action ? arg_list + '&true_no_action=' + this.state.true_No_Action : arg_list

//         //append false action choices
//         // arg_list = this.state.false_log ? arg_list+'&false_log='+this.state.false_log : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_type_id=' + this.state.false_log_selected_type.id : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_GPS=' + this.state.false_log_GPS : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_text=' + this.state.false_log_text : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_no_packages=' + this.state.false_log_package : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_dateTime=' + this.state.false_log_date : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_driver_name=' + this.state.false_log_driver_name : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_customer_name=' + this.state.false_log_customer_name : arg_list
//         arg_list = this.state.false_log ? arg_list + '&false_log_no_packages=' + this.state.false_log_customer_name : arg_list
//         //apend false block option selection
//         arg_list = arg_list + '&false_block=' + this.state.false_block
//         arg_list = this.state.false_block ? arg_list + '&false_block_text=' + this.state.false_block_text : arg_list
//         // false status option
//         arg_list = arg_list + '&false_status=' + this.state.false_status
//         if(this.state.false_status === true){

//             arg_list = this.state.false_status ? arg_list + '&false_status_id=' + this.state.false_selected_status.id : arg_list
//             arg_list =  this.state.false_selected_status_type.id === 0 ? arg_list +'&false_drop_status=true&false_run_status=false' : arg_list + '&false_drop_status=false&false_run_status=true'
//         }

//         //append false record option
//         arg_list = arg_list + '&false_record=' + this.state.false_record
//         //append false take photo
//         arg_list = arg_list + '&false_take_photo=' + this.state.false_take_photo
//         //append false take signature option
//         arg_list = arg_list + '&false_take_signature=' + this.state.false_take_signature
//         // append no action option
//         arg_list = this.state.false_No_Action ? arg_list + '&false_no_action=' + this.state.false_No_Action : arg_list

//         // //(arg_list)
//         const cookies = new Cookies();
//         var http = new XMLHttpRequest();
//         var wizard_ref = this
//         var user_id = cookies.get('user_id')
//         var token = cookies.get('token')
//         //('Token ' + token)
//         http.open('POST', url+'/api/questions/create', true);
//         http.setRequestHeader("Authorization", "Bearer " + token);
//         http.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
//         //("^^^^^^")
//         //(arg_list)
//         http.send('user_id=' + user_id + '' + arg_list)
//         http.onreadystatechange = function () {
//             //(http.responseText)
//             if (http.readyState === 4 && http.status === 200) {
//                 var json = JSON.parse(http.responseText)
//                 if (json.status === 200) {
//                     wizard_ref.setState({ loading: false })
//                     wizard_ref.setState({
//                         message_title: "Success",
//                         message_body: "Question has been created successfully",
//                         message_box_modal: true,
//                         msg_type: 'success',
//                         onClose_target_url: '/create-organization'
//                     })

//                 }
//                 else {
//                     wizard_ref.setState({ loading: false })
//                     wizard_ref.setState({
//                         message_title: "Failure",
//                         message_body: "Question could not be created",
//                         message_box_modal: true,
//                         onClose_target_url: ""
//                     })
//                 }
//             }

//             if(http.readyState === 4 && http.status === 401){
//                 logout()
//             }
//         }

//     }

//     handle_false_block_text_input = () => {
//         var input = document.getElementById('false_block_text_input').value
//         this.setState({
//             false_block_text: input
//         })
//     }

//     render() {

//         if (this.state.current_section === 1) {
//             if(branch_admin === 'true'){
//                 return (

//                     <div>
//                         <div>
//                             <Modal isOpen={messageBoxModal}>
//                                 <ModalHeader>
//                                     <h3>{messageTitle}</h3>
//                                 </ModalHeader>
//                                 <ModalBody>
//                                     <b>{messageBody}</b>
//                                 </ModalBody>
//                                 <ModalFooter>
//                                     <Button color="primary" onClick={closeMessageBoxModal}>Close</Button>
//                                 </ModalFooter>
//                             </Modal>
//                         </div>
//                         <Loader loading={loading} />
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">

//                             <div id="page-content">
//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3>Create Question-Section I</h3>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 {/* <div className='middle-loader'>

//                             </div> */}
//                                 <div className="row" style={{ marginTop: 30 }}>

//                                     <div className="col-md-3">
//                                     </div>
//                                     <div className="col-md-6">
//                                     <div className="right_side_selects">

//                                     <h3>Select Branch</h3>
//                                     <SelectList options={optionsBranch} actionHandler={handleBranchSelect} selectedOption={branch} />
//                                     </div>
//                                     </div>
//                                     <div className="col-md-3">

//                                     </div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 100 }}>
//                                     <div className="col-md-5">
//                                         <div className="org_select">
//                                             <h3>Enter Customer Codes</h3>
//                                             {/* <SelectList options={this.state.options_customers} actionHandler={handleCustomerSelect} selectedOption={this.state.customer} /> */}
//                                             <input class="form-control" placeholder="Customer_Code,Customer_Code,Customer_code" id="cust_code" onBlur={handleCustomerSelect} maxLength={300}></input>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-2">

//                                     </div>
//                                     <div className="col-md-5">
//                                         <div className="right_side_selects">
//                                             <h3>Select Section</h3>
//                                             <SelectList options={optionsSections} actionHandler={handleSectionSelect} selectedOption={section} />
//                                             <button class="btn btn-blue-alt middle-next-btn" id="btn" disabled={btnIsDisabled} onClick={nextSectionTwo}><b>Next</b></button>
//                                         </div>

//                                     </div>
//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 )
//             }
//             else{
//                 return (

//                     <div>
//                         <div>
//                             <Modal isOpen={messageBoxModal}>
//                                 <ModalHeader>
//                                     <h3>{messageTitle}</h3>
//                                 </ModalHeader>
//                                 <ModalBody>
//                                     <b>{messageBody}</b>
//                                 </ModalBody>
//                                 <ModalFooter>
//                                     <Button color="primary" onClick={closeMessageBoxModal}>Close</Button>
//                                 </ModalFooter>
//                             </Modal>
//                         </div>
//                         <Loader loading={loading} />
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">

//                             <div id="page-content">
//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3>Create Question-Section I</h3>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 {/* <div className='middle-loader'>

//                             </div> */}
//                                 <div className="row" style={{ marginTop: 30 }}>

//                                     <div className="col-md-5">
//                                         <div className="org_select">
//                                             <h3>Select Organization</h3>

//                                             <SelectList options={optionsOrganization} actionHandler={handleOrganizationSelect} selectedOption={organization} />
//                                         </div>

//                                     </div>
//                                     <div className="col-md-2">

//                                     </div>
//                                     <div className="col-md-5">
//                                         <div className="right_side_selects">

//                                             <h3>Select Branch</h3>
//                                             <SelectList options={optionsBranch} actionHandler={handleBranchSelect} selectedOption={branch} />
//                                         </div>
//                                     </div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 100 }}>
//                                     <div className="col-md-5">
//                                         <div className="org_select">
//                                             <h3>Enter Customer Codes</h3>
//                                             {/* <SelectList options={this.state.options_customers} actionHandler={handleCustomerSelect} selectedOption={this.state.customer} /> */}
//                                             <input class="form-control" placeholder="Customer_Code,Customer_Code,Customer_code" id="cust_code" onBlur={handleCustomerSelect} maxLength={300}></input>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-2">

//                                     </div>
//                                     <div className="col-md-5">
//                                         <div className="right_side_selects">
//                                             <h3>Select Section</h3>
//                                             <SelectList options={optionsSections} actionHandler={handleSectionSelect} selectedOption={section} />
//                                             <button class="btn btn-blue-alt middle-next-btn" id="btn" disabled={btnIsDisabled} onClick={nextSectionTwo}><b>Next</b></button>
//                                         </div>

//                                     </div>
//                                 </div>

//                             </div>
//                         </div>
//                     </div>
//                 )
//             }
//         }
//         if (this.state.current_section === 2) {
//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={messageBoxModal}>
//                             <ModalHeader>
//                                 <h3>{messageTitle}</h3>
//                             </ModalHeader>
//                             <ModalBody>
//                                 <b>{messageBody}</b>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button color="primary" onClick={closeMessageBoxModal}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>
//                     <div>
//                         <Loader loading={loading} />
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">

//                             <div id="page-content">
//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3 className="s2_heading_text">Create Question-Section II</h3>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 30 }}>

//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <SequenceTable sequences={sequences} activePage={activePage} page_size={pageSize} record={recordSize} fetch={fetchWizardSequence}/>

//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 30 }}>
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3>*Sequence Number</h3>
//                                         <input type='number' className="form-control" placeholder='Enter Sequence Number (1-99)' value={inputSequence} id="sequence_input" onChange={handleSequenceInput}></input>

//                                         <div class="isa_error" hidden={this.state.sequenceErrorMessageHidden}>
//                                         <i class="fa fa-times-circle"></i>
//                                         <b >Sequence number must be a number between 1 and 99</b>
//                                         </div>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row ">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4" >
//                                         <button class="btn btn-blue-alt s2_next_btn" onClick={sectionTwoNextBtnHandle} disabled={btnS2NextDisabled}>Next</button>
//                                         <button onClick={backToSectionTwo} class="btn btn-blue-alt s2_back_btn">Back</button>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }

//         if (this.state.current_section === 3) {
//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={messageBoxModal}>
//                             <ModalHeader>
//                                 <h3>{messageTitle}</h3>
//                             </ModalHeader>
//                             <ModalBody>
//                                 <b>{messageBody}</b>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button color="primary" onClick={closeMessageBoxModal}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>
//                     <div>
//                         <Loader loading={loading} />
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">

//                             <div id="page-content">
//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3 style={{ paddingLeft: 40 }}>Create Question-Section III-Select Question Type</h3>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 30 }}>

//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                     <h3>Question Type</h3>
//                                         <SelectList options={actionTypes} actionHandler={handleActionSelect} selectedOption={action} />
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row" style={{ marginTop: 90 }}>
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3>Question Text</h3>
//                                         <input type='text' className="form-control" placeholder='Enter Question Text' value={actionText} id="q_text_input" onChange={this.handle_question_text_input} maxLength={300}></input>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row ">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4 " >
//                                         <button onClick={backSection3Btn} class="btn btn-blue-alt s2_back_btn">Back</button>
//                                         <button class="btn btn-blue-alt s2_next_btn" onClick={handleBtnNextS3Click} disabled={btnNextS3Disabled}>Next</button>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }
//         if (this.state.current_section === 4) {

//             return (
//                 <div>
//                     <div>
//                         <Modal isOpen={messageBoxModal}>
//                             <ModalHeader>
//                                 <h3>{messageTitle}</h3>
//                             </ModalHeader>
//                             <ModalBody>
//                                 <b>{messageBody}</b>
//                             </ModalBody>
//                             <ModalFooter>
//                                 <Button color="primary" onClick={closeMessageBoxModal}>Close</Button>
//                             </ModalFooter>
//                         </Modal>
//                     </div>
//                     <div>
//                         <Loader loading={loading} />
//                         <div className="clearfix" id="page-header">
//                             <div>
//                                 <Header />
//                             </div>
//                         </div>

//                         <div >
//                             <SideBar />
//                         </div>
//                         <div id="page-content-wrapper" className="rm-transition">

//                             <div id="page-content">

//                                 <div className="row">
//                                     <div className="col-md-4"></div>
//                                     <div className="col-md-4">
//                                         <h3>Create Question-Section V</h3>
//                                     </div>
//                                     <div className="col-md-4"></div>
//                                 </div>
//                                 <div className="row">
//                                     <div className="col-md-5">

//                                         <h3>True Action</h3>
//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={handleTrueLogCheckboxClick}>
//                                                     {/* <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log} disabled={this.state.true_log_disabled} onClick={handleTrueLogCheckboxClick} class="custom-checkbox"></input> */}
//                                                     <input type="checkbox" checked={this.state.true_log}   disabled={this.state.true_log_disabled} onClick={handleTrueLogCheckboxClick} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Log</b>
//                                                     </label>
//                                                 </div>

//                                             </div>
//                                             <div>
//                                                 <Modal isOpen={this.state.true_log_modal}>
//                                                     <ModalHeader>
//                                                         <h3>True Action: Log Options</h3>
//                                                     </ModalHeader>
//                                                     <ModalBody>

//                                                         <div>
//                                                             <h3>Select log Type</h3>
//                                                             <SelectList options={this.state.true_log_list} actionHandler={this.handleLogTypeSelect} selectedOption={this.state.true_log_selected_type} />
//                                                         </div>

//                                                         <div style={{ marginTop: 30, height: 'auto' }}>
//                                                             <h3>Enter Log Text</h3>
//                                                             <textarea type='text' className="form-control " placeholder='Enter Enter Log Text' id="t_log_text" value={this.state.true_log_text} onChange={this.handle_true_log_text_input}></textarea>
//                                                         </div>

//                                                         <div style={{ marginTop: 30, height: 'auto' }}>
//                                                             <h3>Log Options Checklist</h3>
//                                                             <div style={{ marginLeft: 20, height: 'auto' }}>
//                                                                 <div className="row">
//                                                                     <label>
//                                                                         <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log_date} onClick={this.handle_true_log_date_checkbox_click} class="custom-checkbox"></input>
//                                                                         <b className="label-text">Date/Time</b>

//                                                                     </label>
//                                                                 </div>
//                                                                 <div className="row">
//                                                                     <label>
//                                                                         <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log_GPS} onClick={this.handle_true_log_GPS_checkbox_click} class="custom-checkbox"></input>
//                                                                         <b className="label-text">GPS Cordinates</b>

//                                                                     </label>
//                                                                 </div>
//                                                                 <div className="row">
//                                                                     <label>
//                                                                         <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log_package} onClick={this.handle_true_log_package_checkbox_click} class="custom-checkbox"></input>
//                                                                         <b className="label-text">No. of Packages</b>

//                                                                     </label>
//                                                                 </div>
//                                                                 <div className="row">
//                                                                     <label>
//                                                                         <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log_driver_name} onClick={this.handle_true_log_driver_name_checkbox_click} class="custom-checkbox"></input>
//                                                                         <b className="label-text">Driver Name</b>

//                                                                     </label>
//                                                                 </div>
//                                                                 <div className="row">
//                                                                     <label>
//                                                                         <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log_customer_name} onClick={this.handle_true_log_customer_name_checkbox_click} class="custom-checkbox"></input>
//                                                                         <b className="label-text">Customer Name</b>

//                                                                     </label>
//                                                                 </div>
//                                                             </div>
//                                                         </div>

//                                                     </ModalBody>
//                                                     <ModalFooter>
//                                                         <Button color="primary" onClick={this.toggle_true_log_modal}>Done</Button>
//                                                     </ModalFooter>
//                                                 </Modal>
//                                             </div>

//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_block_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_block} disabled={this.state.true_block_disabled} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Block</b>

//                                                     </label>
//                                                 </div>

//                                             </div>
//                                             <div>
//                                                 <Modal isOpen={this.state.true_block_modal}>
//                                                     <ModalHeader>
//                                                         <h3>True Action:Block Text</h3>

//                                                     </ModalHeader>
//                                                     <ModalBody>
//                                                         <h3>Enter Block Text</h3>
//                                                         <input type='text' className="form-control" placeholder='Enter Block Text' onChange={this.handle_block_text_input3} value={this.state.true_block_text} id="block_text_input" maxLength={300}></input>
//                                                     </ModalBody>
//                                                     <ModalFooter>
//                                                         <Button color="primary" onClick={this.toggle_true_block_modal}>Done</Button>
//                                                     </ModalFooter>
//                                                 </Modal>
//                                             </div>
//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_status_status_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_status} disabled={this.state.true_status_disabled} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Status</b>

//                                                     </label>
//                                                 </div>

//                                                 <div>
//                                                     <Modal isOpen={this.state.true_status_modal}>
//                                                         <ModalHeader>
//                                                             <h3>True Action: Status</h3>

//                                                         </ModalHeader>
//                                                         <ModalBody>
//                                                         <h3>Status Type</h3>
//                                                         <SelectList options={this.state.status_type} actionHandler={this.handleStatusTypeSelect} selectedOption={this.state.true_selected_status_type} />
//                                                         <h3>Status Code</h3>
//                                                         <SelectList options={this.state.true_status_list} actionHandler={this.handleStatusSelect} selectedOption={this.state.true_selected_status} />
//                                                         </ModalBody>
//                                                         <ModalFooter>
//                                                             <Button color="primary" onClick={this.toggle_true_status_modal}>Done</Button>
//                                                         </ModalFooter>
//                                                     </Modal>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_record_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_record} disabled={this.state.true_record_disabled} onClick={this.handle_true_record_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Record</b>

//                                                     </label>
//                                                 </div>
//                                             </div>

//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_take_photo_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_take_photo} disabled={this.state.true_take_photo_disabled} onClick={this.handle_true_take_photo_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Take Photo</b>

//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_take_signature_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_take_signature} disabled={this.state.true_take_signature_disabled} onClick={this.handle_true_take_signature_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Take Signature</b>

//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_true_No_Action_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.true_No_Action} disabled={this.state.true_No_Action_disabled} onClick={this.handle_true_No_Action_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">No Action</b>

//                                                     </label>
//                                                 </div>
//                                             </div>

//                                         </div>

//                                     </div>
//                                     <div className="col-md-2">

//                                         <div className="vl">

//                                         </div>

//                                     </div>
//                                     <div className="col-md-5">
//                                         <h3>False Action</h3>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_log_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log} disabled={this.state.false_log_disabled} onClick={this.handle_false_log_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Log</b>
//                                                     </label>
//                                                 </div>

//                                                 <div>
//                                                     <Modal isOpen={this.state.false_log_modal}>
//                                                         <ModalHeader>False Action-Log: Specify Options</ModalHeader>
//                                                         <ModalBody>
//                                                             <h3>Select Log Type</h3>
//                                                             <SelectList options={this.state.false_log_list} actionHandler={this.FalsehandleLogTypeSelect} selectedOption={this.state.false_log_selected_type} />
//                                                             <div style={{ marginTop: 50, height: 'auto' }}>
//                                                                 <h3>Enter Log Text</h3>
//                                                                 <textarea type='text' className="form-control " placeholder='Enter Enter Log Text' id="f_log_text" value={this.state.false_log_text} onChange={this.handle_false_log_text_input}  ></textarea>
//                                                             </div>
//                                                             <div style={{ marginTop: 50, height: 'auto' }}>
//                                                                 <h3>Log Options Checklist</h3>
//                                                                 <div style={{ marginLeft: 10, height: 'auto' }}>
//                                                                     <div className="row">
//                                                                         <label>
//                                                                             <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log_date} onClick={this.handle_false_log_date_checkbox_click} class="custom-checkbox"></input>
//                                                                             <b className="label-text">Date/Time</b>

//                                                                         </label>
//                                                                     </div>
//                                                                     <div className="row">
//                                                                         <label>
//                                                                             <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log_GPS} onClick={this.handle_false_log_GPS_checkbox_click} class="custom-checkbox"></input>
//                                                                             <b className="label-text">GPS Cordinates</b>

//                                                                         </label>
//                                                                     </div>
//                                                                     <div className="row">
//                                                                         <label>
//                                                                             <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log_package} onClick={this.handle_false_log_package_checkbox_click} class="custom-checkbox"></input>
//                                                                             <b className="label-text">No. of Packages</b>

//                                                                         </label>
//                                                                     </div>
//                                                                     <div className="row">
//                                                                         <label>
//                                                                             <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log_driver_name} onClick={this.handle_false_log_driver_name_checkbox_click} class="custom-checkbox"></input>
//                                                                             <b className="label-text">Driver Name</b>

//                                                                         </label>
//                                                                     </div>
//                                                                     <div className="row">
//                                                                         <label>
//                                                                             <input type="checkbox" id="true_log_checkbox" checked={this.state.false_log_customer_name} onClick={this.handle_false_log_customer_name_checkbox_click} class="custom-checkbox"></input>
//                                                                             <b className="label-text">Customer Name</b>

//                                                                         </label>
//                                                                     </div>
//                                                                 </div>
//                                                             </div>

//                                                         </ModalBody>
//                                                         <ModalFooter>

//                                                             <Button color="primary" onClick={this.toggle_false_log_modal}>Done</Button>

//                                                         </ModalFooter>
//                                                     </Modal>
//                                                 </div>

//                                             </div>

//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_block_checkbox_click}>
//                                                     <input type="checkbox" id="true_log_checkbox" checked={this.state.false_block} disabled={this.state.false_block_disabled} onClick={this.handle_false_block_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Block</b>
//                                                     </label>
//                                                 </div>
//                                                 <div>
//                                                     <Modal isOpen={this.state.false_block_modal}>
//                                                         <ModalHeader>
//                                                             <h3>False Action:Block Text</h3>
//                                                         </ModalHeader>
//                                                         <ModalBody>
//                                                             <h3>Enter Block Text</h3>
//                                                             <input type='text' className="form-control" placeholder='Enter Block Text' onChange={this.handle_false_block_text_input} value={this.state.false_block_text} id="false_block_text_input" maxLength={300}></input>
//                                                         </ModalBody>
//                                                         <ModalFooter>
//                                                             <Button color="primary" onClick={this.toggle_false_block_modal}>Done</Button>
//                                                         </ModalFooter>
//                                                     </Modal>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_status_status_checkbox_click}>
//                                                     <input type="checkbox" id="false_log_checkbox" checked={this.state.false_status} disabled={this.state.false_status_disabled} onClick={this.handle_false_status_status_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Status</b>
//                                                     </label>
//                                                 </div>

//                                             </div>
//                                             <div>
//                                                 <Modal isOpen={this.state.false_status_modal}>
//                                                     <ModalHeader>
//                                                         <h3>False Action: Select Status</h3>
//                                                     </ModalHeader>
//                                                     <ModalBody>
//                                                         <h3>Select Status Type</h3>
//                                                         <SelectList options={this.state.status_type} actionHandler={this.FalsehandleStatusTypeSelect} selectedOption={this.state.false_selected_status_type} />
//                                                         <h3>Select Status Code</h3>
//                                                         <SelectList options={this.state.false_status_list} actionHandler={this.FalsehandleStatusSelect} selectedOption={this.state.false_selected_status} />
//                                                     </ModalBody>
//                                                     <ModalFooter>
//                                                         <Button color="primary" onClick={this.toggle_false_status_modal}>Done</Button>
//                                                     </ModalFooter>
//                                                 </Modal>
//                                             </div>

//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_record_checkbox_click}>
//                                                     <input type="checkbox" id="false_log_checkbox" checked={this.state.false_record} disabled={this.state.false_record_disabled} onClick={this.handle_false_record_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Record</b>
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_take_photo_checkbox_click}>
//                                                     <input type="checkbox" id="false_log_checkbox" checked={this.state.false_take_photo} disabled={this.state.false_take_photo_disabled} onClick={this.handle_false_take_photo_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Take Photo</b>
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_take_signature_checkbox_click}>
//                                                     <input type="checkbox" id="false_log_checkbox" checked={this.state.false_take_signature} disabled={this.state.false_take_signature_disabled} onClick={this.handle_false_take_signature_checkbox_click} class="custom-checkbox"></input>
//                                                     <label>
//                                                         <b className="label-text">Take Signature</b>
//                                                     </label>
//                                                 </div>
//                                             </div>

//                                         </div>

//                                         <div className="row form">
//                                             <div className="col-md-12">
//                                                 <div class="inputGroup" onClick={this.handle_false_No_Action_checkbox_click}>
//                                                     <input type="checkbox" id="false_log_checkbox" checked={this.state.false_No_Action} onClick={this.handle_false_No_Action_checkbox_click} class="custom-checkbox" ></input>
//                                                     <label>
//                                                         <b className="label-text">No Action</b>
//                                                     </label>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     </div>

//                                 </div>
//                                 <div className="row">
//                                     <div className="col-md-12">
//                                         <button onClick={this.back_section_4_btn} class="btn btn-blue-alt final_back_btn"><b>Back</b></button>
//                                         <button class="btn btn-blue-alt final_next_btn" onClick={this.create_question}  ><b>Create Question</b></button>
//                                     </div>
//                                     {/* <div className="col-md-4"></div>
//                         <div className="col-md-4">

//                         </div> */}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             )
//         }

//         //Specify false action section
//         if (this.state.current_section === 5) {

//             return(
//                 <div>
//                 <Loader loading={loading} fullPage={true}/>
//             </div>
//             )
//         }
//     }
// }

// export default CreateQuestionPageOne

import React from 'react'
import { Loader } from 'react-overlay-loader'
import 'react-overlay-loader/styles.css'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import Cookies from 'universal-cookie'
import SelectList from '../components/createQuestionSubComponents/dropdownSelect'
import SequenceTable from '../components/createQuestionSubComponents/sequenceTable'
import Header from '../components/dashboardSubComponents/header'
import SideBar from '../components/dashboardSubComponents/sideBarNav'
import { logout, url } from '../components/helper'
// import Pagination from 'react-js-pagination'

const CreateQuestionPageOne = () => {
    //States
    const [superuser, setSuperuser] = React.useState('')
    const [organizationAdmin, setOrganizationAdmin] = React.useState()
    const [branchAdmin, setBranchAdmin] = React.useState()
    const [optionsOrganization, setOptionsOrganization] = React.useState([])
    const [optionsBranch, setOptionsBranch] = React.useState([])
    const [optionsCustomers, setOptionsCustomers] = React.useState([])
    const [optionsSections, setOptionsSections] = React.useState([])
    const [sequences, setSequences] = React.useState([])
    const [sequenceErrorMessageHidden, setSequenceErrorMessageHidden] =
        React.useState(true)
    const [actionTypes, setActionTypes] = React.useState([
        { value: 'Button', label: 'Button', id: 1 },
    ])
    const [organization, setOrganization] = React.useState(null)
    const [branch, setBranch] = React.useState(null)
    const [customer, setCustomer] = React.useState()
    const [section, setSection] = React.useState(null)
    const [action, setAction] = React.useState(null)
    const [actionText, setActionText] = React.useState()
    const [btnIsDisabled, setBtnIsDisabled] = React.useState(true)
    const [btnS2NextDisabled, setBtnS2NextDisabled] = React.useState(true)
    const [btnNextS3Disabled, setBtnNextS3Disabled] = React.useState(true)
    const [currentSection, setCurrentSection] = React.useState(5)
    const [loading, setLoading] = React.useState(true)
    const [alreadyMounted, setAlreadyMounted] = React.useState(false)
    const [sectionTwoMounted, setSectionTwoMounted] = React.useState(false)
    const [inputSequence, setInputSequence] = React.useState(null)
    const [trueLog, setTrueLog] = React.useState(false)
    const [trueLogSelectedType, setTrueLogSelectedType] = React.useState(null)
    const [trueLogList, setTrueLogList] = React.useState([])
    const [trueLogSelectedOption, setTrueLogSelectedOption] =
        React.useState(null)
    const [trueLogText, setTrueLogText] = React.useState(null)
    const [trueLogDate, setTrueLogDate] = React.useState(false)
    const [trueLogGPS, setTrueLogGPS] = React.useState(false)
    const [trueLogPackage, setTrueLogPackage] = React.useState(false)
    const [trueLogDriverName, setTrueLogDriverName] = React.useState(false)
    const [trueLogCustomerName, setTrueLogCustomerName] = React.useState(false)
    const [trueBlock, setTrueBlock] = React.useState(false)
    const [trueBlockText, setTrueBlockText] = React.useState(null)
    const [trueStatusList, setTrueStatusList] = React.useState([])
    const [trueStatus, setTrueStatus] = React.useState(false)
    const [trueSelectedStatus, setTrueSelectedStatus] = React.useState(null)
    const [trueRecord, setTrueRecord] = React.useState(false)
    const [trueTakePhoto, setTrueTakePhoto] = React.useState(false)
    const [trueTakeSignature, setTrueTakeSignature] = React.useState(false)
    const [trueNoAction, setTrueNoAction] = React.useState(false)
    const [falseLog, setFalseLog] = React.useState(false)
    const [falseLogSelectedType, setFalseLogSelectedType] = React.useState(null)
    const [falseLogList, setFalseLogList] = React.useState([])
    const [falseLogSelectedOption, setFalseLogSelectedOption] =
        React.useState(null)
    const [falseLogText, setFalseLogText] = React.useState()
    const [falseLogDate, setFalseLogDate] = React.useState(false)
    const [falseLogGPS, setFalseLogGPS] = React.useState(false)
    const [falseLogPackage, setFalseLogPackage] = React.useState(false)
    const [falseLogDriverName, setFalseLogDriverName] = React.useState(false)
    const [falseLogCustomerName, setFalseLogCustomerName] =
        React.useState(false)
    const [falseBlock, setFalseBlock] = React.useState(false)
    const [falseBlockText, setFalseBlockText] = React.useState(null)
    const [falseStatusList, setFalseStatusList] = React.useState([])
    const [falseStatus, setFalseStatus] = React.useState(false)
    const [falseSelectedStatus, setFalseSelectedStatus] = React.useState(null)
    const [falseRecord, setFalseRecord] = React.useState(false)
    const [falseTakePhoto, setFalseTakePhoto] = React.useState(false)
    const [falseTakeSignature, setFalseTakeSignature] = React.useState(false)
    const [falseNoAction, setFalseNoAction] = React.useState(false)
    const [falseNoActionDisabled, setFalseNoActionDisabled] =
        React.useState(false)
    const [runStatusList, setRunStatusList] = React.useState([])
    const [dropStatusList, setDropStatusList] = React.useState([])
    const [statusType, setStatusType] = React.useState([
        { value: 'Drop', label: 'Drop', id: 0 },
        { label: 'Run', value: 'Run', id: 1 },
    ])
    const [trueSelectedStatusType, setTrueSelectedStatusType] =
        React.useState(null)
    const [falseSelectedStatusType, setFalseSelectedStatusType] =
        React.useState(null)
    const [trueLogModal, setTrueLogModal] = React.useState(false)
    const [trueBlockModal, setTrueBlockModal] = React.useState(false)
    const [trueStatusModal, setTrueStatusModal] = React.useState(false)
    const [falseLogModal, setFalseLogModal] = React.useState(false)
    const [falseBlockModal, setFalseBlockModal] = React.useState(false)
    const [falseStatusModal, setFalseStatusModal] = React.useState(false)
    const [messageBoxModal, setMessageBoxModal] = React.useState(false)
    const [messageTitle, setMessageTitle] = React.useState()
    const [msgType, setMsgType] = React.useState('')
    const [messageBody, setMessageBody] = React.useState()
    const [onCloseTargetUrl, setOnCloseTargetUrl] = React.useState('')
    const [trueLogDisabled, setTrueLogDisabled] = React.useState(false)
    const [trueBlockDisabled, setTrueBlockDisabled] = React.useState(false)
    const [trueStatusDisabled, setTrueStatusDisabled] = React.useState(false)
    const [trueRecordDisabled, setTrueRecordDisabled] = React.useState(false)
    const [trueTakePhotoDisabled, setTrueTakePhotoDisabled] =
        React.useState(false)
    const [trueTakeSignatureDisabled, setTrueTakeSignatureDisabled] =
        React.useState(false)
    const [trueNoActionDisabled, setTrueNoActionDisabled] =
        React.useState(false)
    const [falseLogDisabled, setFalseLogDisabled] = React.useState(false)
    const [falseBlockDisabled, setFalseBlockDisabled] = React.useState(false)
    const [falseStatusDisabled, setFalseStatusDisabled] = React.useState(false)
    const [falseRecordDisabled, setFalseRecordDisabled] = React.useState(false)
    const [falseTakePhotoDisabled, setFalseTakePhotoDisabled] =
        React.useState(false)
    const [falseTakeSignatureDisabled, setFalseTakeSignatureDisabled] =
        React.useState(false)
    const [activePage, setActivePage] = React.useState(1)
    const [pageSize, setPageSize] = React.useState(10)
    const [recordSize, setRecordSize] = React.useState(0)

    //Set all the states back to their original values
    const resetState = () => {
        setOptionsBranch([])
        setSequences([])
        setOrganization(null)
        setBranch(null)
        setCustomer('')
        setSection(null)
        setAction(null)
        setActionText(null)
        setBtnIsDisabled(true)
        setBtnS2NextDisabled(false)
        setBtnNextS3Disabled(true)
        setCurrentSection(1)
        setLoading(false)
        setAlreadyMounted(false)
        setSectionTwoMounted(false)
        setInputSequence(null)

        //True states?
        setTrueLog(false)
        setTrueLogSelectedType(null)
        setTrueLogSelectedOption(null)
        setTrueLogText(null)
        setTrueLogDate(false)
        setTrueLogGPS(false)
        setTrueLogPackage(false)
        setTrueLogDriverName(false)
        setTrueLogCustomerName(false)

        setTrueBlock(false)
        setTrueBlockText(null)

        setTrueStatus(false)
        setTrueSelectedStatus(null)
        setTrueRecord(false)
        setTrueTakePhoto(false)
        setTrueTakeSignature(false)
        setTrueNoAction(false)

        //False States?!
        setFalseLog(false)
        setFalseLogSelectedType(null)
        setFalseLogSelectedOption(null)
        setFalseLogText(null)
        setFalseLogDate(false)
        setFalseLogGPS(false)
        setFalseLogPackage(false)
        setFalseLogDriverName(false)
        setFalseLogCustomerName(false)

        setFalseBlock(false)
        setFalseBlockText(null)

        setFalseStatus(false)
        setFalseSelectedStatus(null)
        setFalseRecord(false)
        setFalseTakePhoto(false)
        setFalseTakeSignature(false)
        setFalseNoAction(false)

        //More True states?
        setTrueLogModal(false)
        setTrueBlockModal(false)
        setTrueStatusModal(false)

        //Even more False states?!
        setFalseLogModal(false)
        setFalseBlockModal(false)
        setFalseStatusModal(false)

        setMessageBoxModal(false)
        setMessageTitle('')
        setMessageBody('')
        setOnCloseTargetUrl('')
    }

    const toggleTrueLogModal = () => {
        setTrueLogModal(!trueLogModal)
    }

    const toggleTrueBlockModal = () => {
        setTrueBlockModal(!trueBlockModal)
    }

    const toggleTrueStatusModal = () => {
        setTrueStatusModal(!trueStatusModal)
    }

    const toggleFalseLogModal = () => {
        setFalseLogModal(!falseLogModal)
    }

    const toggleFalseBlockModal = () => {
        setFalseBlockModal(!falseBlockModal)
    }
    const toggleFalseStatusModal = () => {
        setFalseStatusModal(!falseStatusModal)
    }

    const closeOnSuccess = () => {
        setMessageBoxModal(!messageBoxModal)
        if (branchAdmin === 'true') {
            const opBr = optionsBranch
            setOptionsBranch(opBr)
        }
        resetState()
    }

    const closeMessageBoxModal = () => {
        setMessageBoxModal(!messageBoxModal)
        setLoading(false)

        //PFIX: Do you really need both cond
        if (msgType !== '' && msgType === 'success') {
            //PFIX: Merge with upper condition?
            if (branchAdmin === 'true') {
                const opBr = optionsBranch
                setOptionsBranch(opBr)
                setOrganization({ value: 'all', label: 'all', id: -1 })
            }
            resetState()
        }
    }

    const credentialCheck = () => {
        const cookies = new Cookies()
        const superuser = cookies.get('superuser')
        const organizationAdmin = cookies.get('organization-admin')
        const branchAdmin = cookies.get('branch-admin')
        const branchUser = cookies.get('branch-user')

        const token = cookies.get('token')
        if (!token) {
            window.location = '/login'
        }

        if (branchUser === 'true') {
            window.location = '/dashboard'
        }

        if (!alreadyMounted) {
            setCurrentSection(1)
            setSuperuser(superuser)
            setOrganizationAdmin(organizationAdmin)
            setBranchAdmin(branchAdmin)
        }
    }

    const getWizard = async () => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')
        let path = ''
        if (branchAdmin === 'true') {
            path = `${url}/api/questions/wizard/branch?user_id=${userId}`
        } else {
            path = `${url}/api/questions/wizard/organisation?user_id=${userId}`
        }

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(path, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    if (branchAdmin === 'true') {
                        let branches = []
                        let customer = []
                        let types = []

                        data.branches.forEach((br) => {
                            const branch = {
                                value: br.branch_name,
                                label: br.branch_name,
                                id: br.branch_id,
                            }
                            branches.push(branch)
                        })

                        if (branches.length > 1) {
                            branches.unshift({
                                value: 'all',
                                label: 'all',
                                id: 0,
                            })
                        }

                        data.question_types.forEach((qt) => {
                            const questionTypes = {
                                value: qt.question_type,
                                label: qt.question_type,
                                id: qt.question_type_id,
                            }
                            types.push(questionTypes)
                        })

                        //PFIX: Redundant code
                        customer.unshift({
                            value: 'all',
                            label: 'all',
                            id: 0,
                        })

                        setOrganization({ value: 'all', label: 'all', id: -1 })
                        setActionTypes(types)
                        setLoading(false)
                        setAlreadyMounted(true)
                        setOptionsBranch(branches)
                    } else {
                        let orgs = []
                        let customers = []
                        let types = []

                        data.organisations.forEach((org) => {
                            const organisation = {
                                value: org.org_name,
                                label: org.org_name,
                                id: org.org_id,
                            }
                            orgs.push(organisation)
                        })

                        data.question_types.forEach((qt) => {
                            const questionTypes = {
                                value: qt.question_type,
                                label: qt.question_type,
                                id: qt.question_type_id,
                            }
                            types.push(questionTypes)
                        })

                        if (orgs.length > 1) {
                            orgs.unshift({
                                value: 'all',
                                label: 'all',
                                id: 0,
                            })
                        }

                        customers.unshift({
                            value: 'all',
                            label: 'all',
                            id: 0,
                        })

                        setOptionsOrganization(orgs)
                        setActionTypes(types)
                        setOptionsCustomers(customers)
                        setLoading(false)
                        setAlreadyMounted(true)
                    }
                    break
                case 401:
                    logout()
                    break
                default:
                    console.error('Invalid data', data)
                    setMessageTitle('Connection Error')
                    setMessageBody(
                        'Could not contact server. Please try again by refreshing page out else'
                    )
                    setMessageBoxModal(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setMessageTitle('Could not load data')
            setMessageBody(
                'Server did not respond in time. Try refreshing page or contact your service provider'
            )
            setMessageBoxModal(true)
        }
    }

    React.useEffect(() => {
        credentialCheck()
        getWizard()
    }, [])

    React.useEffect(() => {
        enableBtn()
    }, [organization, branch, section])

    const enableBtn = () => {
        setBtnIsDisabled(
            organization === null || branch === null || section === null
        )
    }
    const handleOrganizationSelect = async (organization) => {
        setOrganization(organization)
        setLoading(true)
        // enableBtn()

        if (organization.id !== 0) {
            setBranch(null)

            //PFIX: Pretty sure this is redundant
            setOrganization(organization)
            setLoading(true)
            // enableBtn()

            const cookies = new Cookies()
            const userId = cookies.get('user_id')
            const token = cookies.get('token')

            const options = {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }

            try {
                const res = await fetch(
                    `${url}/api/questions/wizard/branch?user_id=${userId}&org_id=${organization.id}`,
                    options
                )
                const data = await res.json()

                switch (data.status) {
                    case 200:
                        let branches = []
                        data.branches.forEach((br) => {
                            const branch = {
                                value: br.branch_name,
                                label: br.branch_name,
                                id: br.branch_id,
                            }
                            branches.push(branch)
                        })

                        if (branches.length >= 2) {
                            branches.unshift({
                                value: 'all',
                                label: 'all',
                                id: 0,
                            })
                        }

                        await setOptionsBranch(branches)
                        setLoading(false)
                        break
                    default:
                        console.error('Invalid data', data)
                        setMessageTitle('Connection Error')
                        setMessageBody(
                            'Could not contact server. Please try again by refreshing page out else'
                        )
                        setMessageBoxModal(true)
                        break
                }
            } catch (err) {
                console.error('Error', err)
                setMessageTitle('Could not load data')
                setMessageBody(
                    'Server did not respond in time. Try refreshing page or contact your service provider'
                )
                setMessageBoxModal(true)
            }
        } else {
            let branches = []
            branches.push({
                value: 'all',
                label: 'all',
                id: 0,
            })

            setOptionsBranch(branches)
            setBranch({ value: 'all', label: 'all', id: 0 })
            setLoading(false)
            handleBranchSelect({ value: 'all', label: 'all', id: 0 })
        }
    }

    const handleBranchSelect = async (branch) => {
        setBranch(branch)
        // enableBtn()
        let org_id = ''
        if (organization) {
            org_id = organization.id
        }
        const id = branch.id
        setLoading(true)

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(
                `${url}/api/questions/wizard/runsheet?user_id=${userId}&org_id=${org_id}&branch_id=${id}`,
                options
            )
            const data = await res.json()

            switch (data.status) {
                case 200:
                    let section = []
                    let logTypes = []
                    let dropStatusCodes = []
                    let runStatusCodes = []

                    data.drop_statuses.forEach((ds) => {
                        const drop = {
                            value: ds.status_name,
                            label: ds.status_name,
                            id: ds.status_id,
                        }
                        dropStatusCodes.push(drop)
                    })
                    data.run_statuses.forEach((rs) => {
                        const run = {
                            value: rs.status_name,
                            label: rs.status_name,
                            id: rs.status_id,
                        }
                        runStatusCodes.push(run)
                    })
                    data.question_sections.forEach((qs) => {
                        const questionSections = {
                            value: qs.question_section_type,
                            label: qs.question_section_type,
                            id: qs.question_section_id,
                        }
                        section.push(questionSections)
                        //(section)
                    })
                    data.question_log_types.forEach((qlt) => {
                        const log = {
                            value: qlt.log_type,
                            label: qlt.log_type,
                            id: qlt.log_type_id,
                        }
                        logTypes.push(log)
                    })

                    setLoading(false)
                    setOptionsSections(section)
                    setAlreadyMounted(true)
                    setAlreadyMounted(true)
                    setRunStatusList(runStatusCodes)
                    setDropStatusList(dropStatusCodes)
                    setTrueLogList(logTypes)
                    setFalseLogList(logTypes)
                    break
                default:
                    console.error('Invalid data', data)
                    setLoading(false)
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    const handleCustomerSelect = () => {
        const input = document.getElementById('cust_code').value
        // console.log('INPUT', input)
        if (input === 'undefined') {
            setCustomer(null)
        } else {
            setCustomer(input)
        }
        // setCustomer(input)
    }

    const handleSectionSelect = async (section) => {
        setSection(section)
        // enableBtn()
    }

    const enableNextS3Btn = () => {
        setBtnNextS3Disabled(!action && actionText === '')
    }

    //PFIX: This entire function, why is there so many redundant settings
    const handleActionSelect = (action) => {
        setAction(action)
        setTrueNoAction(false)
        setFalseNoAction(false)
        enableNextS3Btn()

        //PFIX: True and false redundancy?
        setTrueLog(false)
        setTrueBlock(false)
        setTrueStatus(false)
        setTrueRecord(false)
        setTrueTakePhoto(false)
        setTrueTakeSignature(false)
        setTrueNoAction(false)

        setFalseLog(false)
        setFalseBlock(false)
        setFalseStatus(false)
        setFalseRecord(false)
        setFalseTakePhoto(false)
        setFalseTakeSignature(false)
        setFalseNoAction(false)

        if (action.label === 'text') {
            setFalseNoAction(true)
            setTrueNoAction(true)
        }

        if (action.label === 'page') {
            setTrueNoAction(true)
            setTrueLogDisabled(true)
            setTrueBlockDisabled(true)
            setTrueStatusDisabled(true)
            setTrueRecordDisabled(true)
            setTrueTakePhotoDisabled(true)
            setTrueTakeSignatureDisabled(true)
            setTrueNoActionDisabled(true)

            setFalseNoAction(true)
            setFalseLogDisabled(true)
            setFalseBlockDisabled(true)
            setFalseStatusDisabled(true)
            setFalseRecordDisabled(true)
            setFalseTakePhotoDisabled(true)
            setFalseTakeSignatureDisabled(true)
            setFalseNoActionDisabled(true)
        }

        if (action.label === 'log') {
            setFalseNoAction(true)
        }

        if (action.label === 'status') {
            setTrueStatus(true)
            setFalseNoAction(true)
        }
    }

    const nextSectionTwo = async () => {
        setCurrentSection(5)
        setLoading(true)
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        //PFIX: Replace this with a separate constructor function instead
        let baseUrl = `${url}/api/questions/wizard/sequence?user_id=${userId}`
        if (organization.id) {
            baseUrl = `${baseUrl}&org_id=${organization.id}`
        }
        if (branch.id) {
            baseUrl = `${baseUrl}&branch_id=${branch.id}`
        }

        baseUrl = `${baseUrl}&customer_code=${customer}`
        baseUrl = `${baseUrl}&section_id=${section.id}&page=1`

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(baseUrl, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setLoading(false)
                    setCurrentSection(2)
                    setSequences(data.sequences)
                    setRecordSize(data.total_questions)
                    setActivePage(1)
                    break
                default:
                    console.error('Invalid data', data)
                    setMessageTitle('Connection Error')
                    setMessageBody(
                        'Could not contact server. Please try again by refreshing page out else'
                    )
                    setMessageBoxModal(true)
                    setLoading(false)
                    setSequences([])
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setMessageTitle('Connection Error')
            setMessageBody(
                'Could not contact server. Please try again by refreshing page out else'
            )
            setMessageBoxModal(true)
            setLoading(false)
            setSequences([])
        }
    }

    //Originally it was just `fetch`
    //PFIX: How is this different to nextSectionTwo
    const fetchWizardSequence = async (page) => {
        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        //PFIX: Replace this with a separate constructor function instead
        let baseUrl = `${url}/api/questions/wizard/sequence?user_id=${userId}`
        if (organization.id) {
            baseUrl = `${baseUrl}&org_id=${organization.id}`
        }
        if (branch.id) {
            baseUrl = `${baseUrl}&branch_id=${branch.id}`
        }

        baseUrl = `${baseUrl}&customer_code=${customer}`
        baseUrl = `${baseUrl}&section_id=${section.id}&page=${page}`

        const options = {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }

        try {
            const res = await fetch(baseUrl, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setLoading(false)
                    setSequences(data.sequences)
                    setRecordSize(data.total_questions)
                    setActivePage(1)
                    break
                default:
                    console.error('Invalid data', data)
                    setMessageTitle('Connection Error')
                    setMessageBody(
                        'Could not contact server. Please try again by refreshing page out else'
                    )
                    setMessageBoxModal(true)
                    break
            }
        } catch (err) {
            console.error('Error', err)
            setMessageTitle('Connection Error')
            setMessageBody(
                'Could not contact server. Please try again by refreshing page out else'
            )
            setMessageBoxModal(true)
        }
    }

    const handleSequenceInput = () => {
        const inputSequenceLocal =
            document.getElementById('sequence_input').value
        //(input_sequence_local)
        const isNotDecimal =
            parseFloat(inputSequenceLocal) -
                Math.floor(parseFloat(inputSequenceLocal)) !==
            0
        //("is decimal "+isNotDecimal)
        if (
            (inputSequenceLocal > 0) &
            (inputSequenceLocal < 100) &
            !isNotDecimal
        ) {
            setBtnS2NextDisabled(false)
            setInputSequence(inputSequenceLocal)
            setSequenceErrorMessageHidden(true)
        } else {
            setBtnS2NextDisabled(true)
            setInputSequence(inputSequenceLocal)
            setSequenceErrorMessageHidden(false)
        }
    }

    const backToSectionTwo = () => {
        setCurrentSection(1)
    }

    //SECTION 3 HANDLE

    const sectionTwoNextBtnHandle = () => {
        setCurrentSection(3)
    }

    const handleTrueLogCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page'
        ) {
            return
        }

        //PFIX: I don't even know what is going on here
        if (!trueNoAction) {
            const currentState = trueLog
            const modal = !currentState
            setTrueLog(!currentState)
            setTrueLogModal(modal)
        }
    }

    const handleLogTypeSelect = (trueLogSelectedType) => {
        setTrueLogSelectedType(trueLogSelectedType)
    }

    const trueLogTextArea = () => {
        const value = document.getElementById('true_log_text').value
        setTrueLogText(value)
    }

    const handleTrueLogGPSCheckboxClick = () => {
        setTrueLogGPS(!trueLogGPS)
    }

    const handleTrueLogPackageCheckboxClick = () => {
        setTrueLogPackage(!trueLogPackage)
    }

    const handleTrueLogDriverNameCheckboxClick = () => {
        setTrueLogDriverName(!trueLogDriverName)
    }

    const handleTrueLogCustomerNameCheckboxClick = () => {
        setTrueLogCustomerName(!trueLogCustomerName)
    }

    const handleTrueBlockCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log' ||
            action.label === 'button'
        ) {
            return
        }

        const current = trueBlock
        const modal = !current
        //PFIX: What is the holy hell again?!
        if (!trueNoAction) {
            setTrueBlock(!current)
            setTrueBlockModal(modal)
        }
        if (!current) {
            setTrueTakePhoto(false)
            setTrueTakeSignature(false)
            setTrueNoAction(false)
        }
    }

    //PFIX: handle* functions need a fixing
    const handleTrueRecordCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }
        if (!trueNoAction) {
            setTrueRecord(!trueRecord)
        }
    }

    const handleTrueStatusCheckboxClick = () => {
        if (
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }
        if (!trueNoAction) {
            const current = trueStatus
            const modal = !current
            setTrueStatus(!current)
            setTrueStatusModal(modal)
        }
    }

    const handleStatusSelect = (trueSelectedStatus) => {
        setTrueSelectedStatus(trueSelectedStatus)
    }

    const handleStatusTypeSelect = (trueSelectedStatusType) => {
        // true_status_list
        let list = []
        if (trueSelectedStatusType.id === 0) {
            list = dropStatusList
        } else {
            list = runStatusList
        }
        setTrueSelectedStatusType(trueSelectedStatusType)
        // setTrueStatus(list) // PFIX
        setTrueStatusList(list)
    }

    const handleFalseStatusTypeSelect = (falseSelectedStatusType) => {
        setFalseSelectedStatusType(falseSelectedStatusType)
    }

    const handleTrueTakePhotoCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log' ||
            trueBlock
        ) {
            return
        }
        if (!trueNoAction) {
            const current = trueTakePhoto
            setTrueTakePhoto(!current)
            setTrueTakeSignature(false)
        }
    }

    const handleTrueTakeSignatureCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log' ||
            trueBlock
        ) {
            return
        }
        if (!trueNoAction) {
            const current = trueTakeSignature
            setTrueTakeSignature(!current)
            setTrueTakePhoto(false)
        }
    }

    const handleTrueNoActionCheckboxClick = () => {
        const current = trueNoAction
        setTrueLog(false)
        setTrueBlock(false)
        setTrueStatus(false)
        setTrueRecord(false)
        setTrueTakePhoto(false)
        setTrueTakeSignature(false)
        setTrueNoAction(!current)
    }

    const handleQuestionTextInput = () => {
        const input = document.getElementById('q_text_input').value
        setActionText(input)
        enableNextS3Btn()
    }

    const handleBtnNextS3Click = () => {
        setCurrentSection(4)
    }

    //SECTION 4 HANDLE

    const handleFalseLogCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }
        if (!falseNoAction) {
            const current = falseLog
            const modal = !current
            setFalseLog(!current)
            setFalseLogModal(modal)
        }
    }

    const falseHandleLogTypeSelect = (falseLogSelectedType) => {
        setFalseLogSelectedType(falseLogSelectedType)
    }

    const falseLogTextArea = () => {
        const value = document.getElementById('false_log_text').value
        setFalseLogText(value)
    }

    const handleFalseLogDateCheckboxClick = () => {
        setFalseLogDate(!falseLogDate)
    }

    const handleFalseLogGPSCheckboxClick = () => {
        setFalseLogGPS(!falseLogGPS)
    }

    const handleFalseLogPackageCheckboxClick = () => {
        setFalseLogPackage(!falseLogPackage)
    }

    const handleFalseLogDriverNameCheckboxClick = () => {
        setFalseLogDriverName(!falseLogDriverName)
    }

    const handleFalseLogCustomerNameCheckboxClick = () => {
        setFalseLogCustomerName(!falseLogCustomerName)
    }

    const handleFalseBlockCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }

        const current = falseBlock

        if (!falseNoAction) {
            const modal = !current
            setFalseBlock(!current)
            setFalseBlockModal(modal)
        }

        if (!current) {
            setFalseTakePhoto(false)
            setFalseTakeSignature(false)
            setFalseNoAction(false)
        }
    }
    const handleFalseRecordCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }
        if (!falseNoAction) {
            setFalseRecord(!falseRecord)
        }
    }

    const handleFalseStatusCheckboxClick = () => {
        if (
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log'
        ) {
            return
        }

        if (!falseNoAction) {
            setFalseStatus(!falseStatus)
            setFalseStatusModal(!falseStatus)
        }
    }

    const falseHandleStatusTypeSelect = (falseSelectedStatusType) => {
        let list = []
        if (falseSelectedStatusType.id === 0) {
            list = dropStatusList
        } else {
            list = runStatusList
        }
        setFalseSelectedStatusType(falseSelectedStatusType)
        setFalseStatusList(list)
    }

    const falseHandleStatusSelect = (falseSelectedStatus) => {
        setFalseSelectedStatus(falseSelectedStatus)
    }

    const handleFalseTakePhotoCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log' ||
            falseBlock ||
            action.label === 'button'
        ) {
            return
        }
        if (!falseNoAction) {
            setFalseTakePhoto(!falseTakePhoto)
            setFalseTakeSignature(false)
        }
    }

    const handleFalseTakeSignatureCheckboxClick = () => {
        if (
            action.label === 'status' ||
            action.label === 'text' ||
            action.label === 'page' ||
            action.label === 'log' ||
            falseBlock ||
            action.label === 'button'
        ) {
            return
        }
        if (!falseNoAction) {
            setFalseTakeSignature(!falseTakeSignature)
            setFalseTakePhoto(false)
        }
    }

    const handleTrueLogTextInput = () => {
        const input = document.getElementById('t_log_text').value
        setTrueLogText(input)
    }

    const handleFalseLogTextInput = () => {
        const input = document.getElementById('f_log_text').value
        setFalseLogText(input)
    }

    const handleTrueLogDateCheckboxClick = () => {
        setTrueLogDate(!trueLogDate)
    }

    const handleFalseNoActionCheckboxClick = () => {
        if (action.label === 'text') {
            return
        }
        setFalseLog(false)
        setFalseBlock(false)
        setFalseStatus(false)
        setFalseRecord(false)
        setFalseTakePhoto(false)
        setFalseTakeSignature(false)
        setFalseNoAction(!falseNoAction)
    }

    const handleBlockTextInput3 = () => {
        const input = document.getElementById('block_text_input').value
        setTrueBlockText(input)
    }

    const sectionThreeNextBtnHandle = () => {
        if (
            trueLog === false &&
            trueBlock === false &&
            trueStatus === false &&
            trueRecord === false &&
            trueTakePhoto === false &&
            trueTakeSignature === false &&
            trueNoAction === false
        ) {
            alert(
                "No False Actions have been specified kindly specify at least one action or check 'No Action' to continue"
            )
            return
        }
        if (trueLog && !trueLogSelectedOption) {
            alert('You have checked log option. Please also select type of log')
            return
        }

        if (trueBlock && !trueBlockText) {
            alert('You have checked block option. Please also Enter block text')
            return
        }
        if (trueStatus && !trueSelectedStatus) {
            alert(
                'You have checked Status option. Please also select status code'
            )
            return
        } else {
            setCurrentSection(5)
        }
    }

    const backSection3Btn = () => {
        setCurrentSection(2)
    }

    const backSection4Btn = () => {
        setCurrentSection(3)
    }

    const backSection5Btn = () => {
        setCurrentSection(4)
    }

    const handleFalseBlockTextInput = () => {
        const input = document.getElementById('false_block_text_input').value
        setFalseBlockText(input)
    }

    const createQuestion = async () => {
        setLoading(true)
        if (
            trueLog === false &&
            trueBlock === false &&
            trueStatus === false &&
            trueRecord === false &&
            trueTakePhoto === false &&
            trueTakeSignature === false &&
            trueNoAction === false
        ) {
            setMessageTitle('No True Action Specified')
            setMessageBody(
                "No True Actions have been specified kindly specify at least one action or check 'No Action' to continue"
            )
            setMessageBoxModal(true)
            return
        }

        if (trueLog && !trueLogSelectedType) {
            setMessageTitle('Type of log unselected')
            setMessageBody(
                'You have checked log option for True action. Please also select type of log'
            )
            setMessageBoxModal(true)
            return
        }

        if (trueBlock && !trueBlockText) {
            setMessageTitle('No Block Text')
            setMessageBody(
                'You have checked block option for true action. Please also Enter block text'
            )
            setMessageBoxModal(true)
            return
        }
        if (trueStatus === true && trueSelectedStatus === null) {
            setMessageTitle('No Status Code')
            setMessageBody(
                'You have checked status option for true action. Please also select status code'
            )
            setMessageBoxModal(true)
            return
        }
        if (
            falseLog === false &&
            falseBlock === false &&
            falseStatus === false &&
            falseRecord === false &&
            falseTakePhoto === false &&
            falseTakeSignature === false &&
            falseNoAction === false
        ) {
            setMessageTitle('No False Action Specified')
            setMessageBody(
                "No False Actions have been specified kindly specify atleast one action or check 'No Action' to continue"
            )
            setMessageBoxModal(true)
            return
        }
        if (falseLog === true && falseLogSelectedType === null) {
            setMessageTitle('No Log Type Selected')
            setMessageBody(
                'You have checked log option for false action. Please also select type of log'
            )
            setMessageBoxModal(true)
            return
        }

        if (falseBlock === true && falseBlockText === null) {
            setMessageTitle('No Block Text')
            setMessageBody(
                'You have checked block option for false action. Please also Enter block text'
            )
            setMessageBoxModal(true)
            return
        }

        if (falseStatus === true && falseSelectedStatus === null) {
            setMessageTitle('No Status Code Selected')
            setMessageBody(
                'You have checked status option for false action. Please also select status code'
            )
            setMessageBoxModal(true)
            return
        }

        if (trueBlock === true && falseBlock === true) {
            setMessageTitle('Multiple Block options specified')
            setMessageBody(
                'You have checked Block option for both true andd false actions. You can not select block option for both actions'
            )
            setMessageBoxModal(true)
            return
        }

        // console.log('TRUE STATUS', trueStatus)
        // console.log('TRUE SELECTED STATUS', trueSelectedStatus)
        // console.log('FALSE STATUS', falseStatus)
        // console.log('FALSE SELECTED STATUS', falseSelectedStatus)

        let arg_list =
            '&org_id=' +
            organization.id +
            '&branch_id=' +
            branch.id +
            '&section_id=' +
            section.id +
            '&sequence=' +
            inputSequence +
            '&true_log=' +
            trueLog +
            '&customer_code=' +
            customer +
            '&question_type=' +
            action.id +
            '&question_text=' +
            actionText +
            '&false_log=' +
            falseLog
        arg_list = trueLog
            ? arg_list + '&true_log_type_id=' + trueLogSelectedType.id
            : arg_list
        arg_list = trueLog ? arg_list + '&true_log_GPS=' + trueLogGPS : arg_list
        arg_list = trueLog
            ? arg_list + '&true_log_text=' + trueLogText
            : arg_list
        arg_list = trueLog
            ? arg_list + '&true_log_no_packages=' + trueLogPackage
            : arg_list
        arg_list = trueLog
            ? arg_list + '&true_log_dateTime=' + trueLogDate
            : arg_list
        arg_list = trueLog
            ? arg_list + '&true_log_driver_name=' + trueLogDriverName
            : arg_list
        arg_list = trueLog
            ? arg_list + '&true_log_customer_name=' + trueLogCustomerName
            : arg_list

        arg_list = arg_list + '&true_block=' + trueBlock
        arg_list = trueBlock
            ? arg_list + '&true_block_text=' + trueBlockText
            : arg_list

        arg_list = arg_list + '&true_status=' + trueStatus

        if (trueStatus) {
            arg_list = trueStatus
                ? arg_list + '&true_status_id=' + trueSelectedStatus.id
                : arg_list
            arg_list =
                trueSelectedStatusType.id === 0
                    ? arg_list + '&true_drop_status=true&true_run_status=false'
                    : arg_list + '&true_drop_status=false&true_run_status=true'
        }

        //append true record option
        arg_list = arg_list + '&true_record=' + trueRecord

        //append true take photo
        arg_list = arg_list + '&true_take_photo=' + trueTakePhoto

        //append true take signature option
        arg_list = arg_list + '&true_take_signature=' + trueTakeSignature

        // append no action option
        arg_list = trueNoAction
            ? arg_list + '&true_no_action=' + trueNoAction
            : arg_list

        arg_list = falseLog
            ? arg_list + '&false_log_type_id=' + falseLogSelectedType.id
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_GPS=' + falseLogGPS
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_text=' + falseLogText
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_no_packages=' + falseLogPackage
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_dateTime=' + falseLogDate
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_driver_name=' + falseLogDriverName
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_customer_name=' + falseLogCustomerName
            : arg_list
        arg_list = falseLog
            ? arg_list + '&false_log_no_packages=' + falseLogCustomerName //PFIX: What? why customer name?
            : arg_list

        arg_list = arg_list + '&false_block=' + falseBlock
        arg_list = falseBlock
            ? arg_list + '&false_block_text=' + falseBlockText
            : arg_list

        arg_list = arg_list + '&false_status=' + falseStatus

        //PFIX: What does this do with the line above?
        if (falseStatus) {
            arg_list = falseStatus
                ? arg_list + '&false_status_id=' + falseSelectedStatus.id
                : arg_list
            arg_list =
                falseSelectedStatusType.id === 0
                    ? arg_list +
                      '&false_drop_status=true&false_run_status=false'
                    : arg_list +
                      '&false_drop_status=false&false_run_status=true'
        }

        //append false record option
        arg_list = arg_list + '&false_record=' + falseRecord

        //append false take photo
        arg_list = arg_list + '&false_take_photo=' + falseTakePhoto

        //append false take signature option
        arg_list = arg_list + '&false_take_signature=' + falseTakeSignature

        // append no action option
        arg_list = falseNoAction
            ? arg_list + '&false_no_action=' + falseNoAction
            : arg_list

        const cookies = new Cookies()
        const userId = cookies.get('user_id')
        const token = cookies.get('token')

        const options = {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-type': 'application/x-www-form-urlencoded',
            },
            body: `user_id=${userId}${arg_list}`,
        }

        try {
            const res = await fetch(`${url}/api/questions/create`, options)
            const data = await res.json()

            switch (data.status) {
                case 200:
                    setLoading(false)
                    setMessageTitle('Success')
                    setMessageBody('Question has been created successfully')
                    setMessageBoxModal(true)
                    setMsgType('success')
                    setOnCloseTargetUrl('/create-organization')
                    break
                case 401:
                    logout()
                    break
                default:
                    console.error('Invalid data', data)
                    setMessageTitle('Failure')
                    setMessageBody('Question could not be created')
                    setMessageBoxModal(true)
                    setOnCloseTargetUrl('')
                    break
            }
        } catch (err) {
            console.error('Error', err)
        }
    }

    return (
        <div>
            {currentSection === 1 ? (
                <div>
                    {branchAdmin === 'true' ? (
                        <div>
                            <div>
                                <div>
                                    <Modal isOpen={messageBoxModal}>
                                        <ModalHeader>
                                            <h3>{messageTitle}</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                            <b>{messageBody}</b>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                color="primary"
                                                onClick={closeMessageBoxModal}
                                            >
                                                Close
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                                <Loader loading={loading} />
                                <div className="clearfix" id="page-header">
                                    <div>
                                        <Header />
                                    </div>
                                </div>

                                <div>
                                    <SideBar />
                                </div>
                                <div
                                    id="page-content-wrapper"
                                    className="rm-transition"
                                >
                                    <div id="page-content">
                                        <div className="row">
                                            <div className="col-md-4"></div>
                                            <div className="col-md-4">
                                                <h3>
                                                    Create Question-Section I
                                                </h3>
                                            </div>
                                            <div className="col-md-4"></div>
                                        </div>
                                        <div
                                            className="row"
                                            style={{ marginTop: 30 }}
                                        >
                                            <div className="col-md-3"></div>
                                            <div className="col-md-6">
                                                <div className="right_side_selects">
                                                    <h3>Select Branch</h3>
                                                    <SelectList
                                                        options={optionsBranch}
                                                        actionHandler={
                                                            handleBranchSelect
                                                        }
                                                        selectedOption={branch}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-3"></div>
                                        </div>
                                        <div
                                            className="row"
                                            style={{ marginTop: 100 }}
                                        >
                                            <div className="col-md-5">
                                                <div className="org_select">
                                                    <h3>
                                                        Enter Customer Codes
                                                    </h3>
                                                    <input
                                                        class="form-control"
                                                        placeholder="Customer_Code,Customer_Code,Customer_code"
                                                        id="cust_code"
                                                        onBlur={
                                                            handleCustomerSelect
                                                        }
                                                        maxLength={300}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className="col-md-2"></div>
                                            <div className="col-md-5">
                                                <div className="right_side_selects">
                                                    <h3>Select Section</h3>
                                                    <SelectList
                                                        options={
                                                            optionsSections
                                                        }
                                                        actionHandler={
                                                            handleSectionSelect
                                                        }
                                                        selectedOption={section}
                                                    />
                                                    <button
                                                        class="btn btn-blue-alt middle-next-btn"
                                                        id="btn"
                                                        disabled={btnIsDisabled}
                                                        onClick={nextSectionTwo}
                                                    >
                                                        <b>Next</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <div>
                            <div>
                                <div>
                                    <Modal isOpen={messageBoxModal}>
                                        <ModalHeader>
                                            <h3>{messageTitle}</h3>
                                        </ModalHeader>
                                        <ModalBody>
                                            <b>{messageBody}</b>
                                        </ModalBody>
                                        <ModalFooter>
                                            <Button
                                                color="primary"
                                                onClick={closeMessageBoxModal}
                                            >
                                                Close
                                            </Button>
                                        </ModalFooter>
                                    </Modal>
                                </div>
                                <Loader loading={loading} />
                                <div className="clearfix" id="page-header">
                                    <div>
                                        <Header />
                                    </div>
                                </div>

                                <div>
                                    <SideBar />
                                </div>
                                <div
                                    id="page-content-wrapper"
                                    className="rm-transition"
                                >
                                    <div id="page-content">
                                        <div className="row">
                                            <div className="col-md-4"></div>
                                            <div className="col-md-4">
                                                <h3>
                                                    Create Question-Section I
                                                </h3>
                                            </div>
                                            <div className="col-md-4"></div>
                                        </div>
                                        {/* <div className='middle-loader'>

                                     </div> */}
                                        <div
                                            className="row"
                                            style={{ marginTop: 30 }}
                                        >
                                            <div className="col-md-5">
                                                <div className="org_select">
                                                    <h3>Select Organization</h3>

                                                    <SelectList
                                                        options={
                                                            optionsOrganization
                                                        }
                                                        actionHandler={
                                                            handleOrganizationSelect
                                                        }
                                                        selectedOption={
                                                            organization
                                                        }
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-md-2"></div>
                                            <div className="col-md-5">
                                                <div className="right_side_selects">
                                                    <h3>Select Branch</h3>
                                                    <SelectList
                                                        options={optionsBranch}
                                                        actionHandler={
                                                            handleBranchSelect
                                                        }
                                                        selectedOption={branch}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            className="row"
                                            style={{ marginTop: 100 }}
                                        >
                                            <div className="col-md-5">
                                                <div className="org_select">
                                                    <h3>
                                                        Enter Customer Codes
                                                    </h3>
                                                    {/* <SelectList options={this.state.options_customers} actionHandler={handleCustomerSelect} selectedOption={this.state.customer} /> */}
                                                    <input
                                                        class="form-control"
                                                        placeholder="Customer_Code,Customer_Code,Customer_code"
                                                        id="cust_code"
                                                        onBlur={
                                                            handleCustomerSelect
                                                        }
                                                        maxLength={300}
                                                    ></input>
                                                </div>
                                            </div>
                                            <div className="col-md-2"></div>
                                            <div className="col-md-5">
                                                <div className="right_side_selects">
                                                    <h3>Select Section</h3>
                                                    <SelectList
                                                        options={
                                                            optionsSections
                                                        }
                                                        actionHandler={
                                                            handleSectionSelect
                                                        }
                                                        selectedOption={section}
                                                    />
                                                    <button
                                                        class="btn btn-blue-alt middle-next-btn"
                                                        id="btn"
                                                        disabled={btnIsDisabled}
                                                        onClick={nextSectionTwo}
                                                    >
                                                        <b>Next</b>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            ) : (
                <div></div>
            )}
            {currentSection === 2 ? (
                <div>
                    <div>
                        <Modal isOpen={messageBoxModal}>
                            <ModalHeader>
                                <h3>{messageTitle}</h3>
                            </ModalHeader>
                            <ModalBody>
                                <b>{messageBody}</b>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeMessageBoxModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Loader loading={loading} />
                        <div className="clearfix" id="page-header">
                            <div>
                                <Header />
                            </div>
                        </div>

                        <div>
                            <SideBar />
                        </div>
                        <div
                            id="page-content-wrapper"
                            className="rm-transition"
                        >
                            <div id="page-content">
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3 className="s2_heading_text">
                                            Create Question-Section II
                                        </h3>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row" style={{ marginTop: 30 }}>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <SequenceTable
                                            sequences={sequences}
                                            activePage={activePage}
                                            page_size={pageSize}
                                            record={recordSize}
                                            fetch={fetchWizardSequence}
                                        />
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row" style={{ marginTop: 30 }}>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3>*Sequence Number</h3>
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Sequence Number (1-99)"
                                            value={inputSequence}
                                            id="sequence_input"
                                            onChange={handleSequenceInput}
                                        ></input>

                                        <div
                                            class="isa_error"
                                            hidden={sequenceErrorMessageHidden}
                                        >
                                            <i class="fa fa-times-circle"></i>
                                            <b>
                                                Sequence number must be a number
                                                between 1 and 99
                                            </b>
                                        </div>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <button
                                            class="btn btn-blue-alt s2_next_btn"
                                            onClick={sectionTwoNextBtnHandle}
                                            disabled={btnS2NextDisabled}
                                        >
                                            Next
                                        </button>
                                        <button
                                            onClick={backToSectionTwo}
                                            class="btn btn-blue-alt s2_back_btn"
                                        >
                                            Back
                                        </button>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {currentSection === 3 ? (
                <div>
                    <div>
                        <Modal isOpen={messageBoxModal}>
                            <ModalHeader>
                                <h3>{messageTitle}</h3>
                            </ModalHeader>
                            <ModalBody>
                                <b>{messageBody}</b>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeMessageBoxModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Loader loading={loading} />
                        <div className="clearfix" id="page-header">
                            <div>
                                <Header />
                            </div>
                        </div>

                        <div>
                            <SideBar />
                        </div>
                        <div
                            id="page-content-wrapper"
                            className="rm-transition"
                        >
                            <div id="page-content">
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3 style={{ paddingLeft: 40 }}>
                                            Create Question-Section III-Select
                                            Question Type
                                        </h3>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row" style={{ marginTop: 30 }}>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3>Question Type</h3>
                                        <SelectList
                                            options={actionTypes}
                                            actionHandler={handleActionSelect}
                                            selectedOption={action}
                                        />
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row" style={{ marginTop: 90 }}>
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3>Question Text</h3>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Question Text"
                                            value={actionText}
                                            id="q_text_input"
                                            onChange={handleQuestionTextInput}
                                            maxLength={300}
                                        ></input>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row ">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4 ">
                                        <button
                                            onClick={backSection3Btn}
                                            class="btn btn-blue-alt s2_back_btn"
                                        >
                                            Back
                                        </button>
                                        <button
                                            class="btn btn-blue-alt s2_next_btn"
                                            onClick={handleBtnNextS3Click}
                                            disabled={btnNextS3Disabled}
                                        >
                                            Next
                                        </button>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {currentSection === 4 ? (
                <div>
                    <div>
                        <Modal isOpen={messageBoxModal}>
                            <ModalHeader>
                                <h3>{messageTitle}</h3>
                            </ModalHeader>
                            <ModalBody>
                                <b>{messageBody}</b>
                            </ModalBody>
                            <ModalFooter>
                                <Button
                                    color="primary"
                                    onClick={closeMessageBoxModal}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                    <div>
                        <Loader loading={loading} />
                        <div className="clearfix" id="page-header">
                            <div>
                                <Header />
                            </div>
                        </div>

                        <div>
                            <SideBar />
                        </div>
                        <div
                            id="page-content-wrapper"
                            className="rm-transition"
                        >
                            <div id="page-content">
                                <div className="row">
                                    <div className="col-md-4"></div>
                                    <div className="col-md-4">
                                        <h3>Create Question-Section V</h3>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                        <h3>True Action</h3>
                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueLogCheckboxClick
                                                    }
                                                >
                                                    {/* <input type="checkbox" id="true_log_checkbox" checked={this.state.true_log} disabled={this.state.true_log_disabled} onClick={handleTrueLogCheckboxClick} class="custom-checkbox"></input> */}
                                                    <input
                                                        type="checkbox"
                                                        checked={trueLog}
                                                        disabled={
                                                            trueLogDisabled
                                                        }
                                                        onClick={
                                                            handleTrueLogCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Log
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                <Modal isOpen={trueLogModal}>
                                                    <ModalHeader>
                                                        <h3>
                                                            True Action: Log
                                                            Options
                                                        </h3>
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <div>
                                                            <h3>
                                                                Select log Type
                                                            </h3>
                                                            <SelectList
                                                                options={
                                                                    trueLogList
                                                                }
                                                                actionHandler={
                                                                    handleLogTypeSelect
                                                                }
                                                                selectedOption={
                                                                    trueLogSelectedType
                                                                }
                                                            />
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop: 30,
                                                                height: 'auto',
                                                            }}
                                                        >
                                                            <h3>
                                                                Enter Log Text
                                                            </h3>
                                                            <textarea
                                                                type="text"
                                                                className="form-control "
                                                                placeholder="Enter Enter Log Text"
                                                                id="t_log_text"
                                                                value={
                                                                    trueLogText
                                                                }
                                                                onChange={
                                                                    handleTrueLogTextInput
                                                                }
                                                            ></textarea>
                                                        </div>

                                                        <div
                                                            style={{
                                                                marginTop: 30,
                                                                height: 'auto',
                                                            }}
                                                        >
                                                            <h3>
                                                                Log Options
                                                                Checklist
                                                            </h3>
                                                            <div
                                                                style={{
                                                                    marginLeft: 20,
                                                                    height: 'auto',
                                                                }}
                                                            >
                                                                <div className="row">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="true_log_checkbox"
                                                                            checked={
                                                                                trueLogDate
                                                                            }
                                                                            onClick={
                                                                                handleTrueLogDateCheckboxClick
                                                                            }
                                                                            class="custom-checkbox"
                                                                        ></input>
                                                                        <b className="label-text">
                                                                            Date/Time
                                                                        </b>
                                                                    </label>
                                                                </div>
                                                                <div className="row">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="true_log_checkbox"
                                                                            checked={
                                                                                trueLogGPS
                                                                            }
                                                                            onClick={
                                                                                handleTrueLogGPSCheckboxClick
                                                                            }
                                                                            class="custom-checkbox"
                                                                        ></input>
                                                                        <b className="label-text">
                                                                            GPS
                                                                            Cordinates
                                                                        </b>
                                                                    </label>
                                                                </div>
                                                                <div className="row">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="true_log_checkbox"
                                                                            checked={
                                                                                trueLogPackage
                                                                            }
                                                                            onClick={
                                                                                handleTrueLogPackageCheckboxClick
                                                                            }
                                                                            class="custom-checkbox"
                                                                        ></input>
                                                                        <b className="label-text">
                                                                            No.
                                                                            of
                                                                            Packages
                                                                        </b>
                                                                    </label>
                                                                </div>
                                                                <div className="row">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="true_log_checkbox"
                                                                            checked={
                                                                                trueLogDriverName
                                                                            }
                                                                            onClick={
                                                                                handleTrueLogDriverNameCheckboxClick
                                                                            }
                                                                            class="custom-checkbox"
                                                                        ></input>
                                                                        <b className="label-text">
                                                                            Driver
                                                                            Name
                                                                        </b>
                                                                    </label>
                                                                </div>
                                                                <div className="row">
                                                                    <label>
                                                                        <input
                                                                            type="checkbox"
                                                                            id="true_log_checkbox"
                                                                            checked={
                                                                                trueLogCustomerName
                                                                            }
                                                                            onClick={
                                                                                handleTrueLogCustomerNameCheckboxClick
                                                                            }
                                                                            class="custom-checkbox"
                                                                        ></input>
                                                                        <b className="label-text">
                                                                            Customer
                                                                            Name
                                                                        </b>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button
                                                            color="primary"
                                                            onClick={
                                                                toggleTrueLogModal
                                                            }
                                                        >
                                                            Done
                                                        </Button>
                                                    </ModalFooter>
                                                </Modal>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueBlockCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={trueBlock}
                                                        disabled={
                                                            trueBlockDisabled
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Block
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                <Modal isOpen={trueBlockModal}>
                                                    <ModalHeader>
                                                        <h3>
                                                            True Action:Block
                                                            Text
                                                        </h3>
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <h3>
                                                            Enter Block Text
                                                        </h3>
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            placeholder="Enter Block Text"
                                                            onChange={
                                                                handleBlockTextInput3
                                                            }
                                                            value={
                                                                trueBlockText
                                                            }
                                                            id="block_text_input"
                                                            maxLength={300}
                                                        ></input>
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button
                                                            color="primary"
                                                            onClick={
                                                                toggleTrueBlockModal
                                                            }
                                                        >
                                                            Done
                                                        </Button>
                                                    </ModalFooter>
                                                </Modal>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueStatusCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={trueStatus}
                                                        disabled={
                                                            trueStatusDisabled
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Status
                                                        </b>
                                                    </label>
                                                </div>

                                                <div>
                                                    <Modal
                                                        isOpen={trueStatusModal}
                                                    >
                                                        <ModalHeader>
                                                            <h3>
                                                                True Action:
                                                                Status
                                                            </h3>
                                                        </ModalHeader>
                                                        <ModalBody>
                                                            <h3>Status Type</h3>
                                                            <SelectList
                                                                options={
                                                                    statusType
                                                                }
                                                                actionHandler={
                                                                    handleStatusTypeSelect
                                                                }
                                                                selectedOption={
                                                                    trueSelectedStatusType
                                                                }
                                                            />
                                                            <h3>Status Code</h3>
                                                            <SelectList
                                                                options={
                                                                    trueStatusList
                                                                }
                                                                actionHandler={
                                                                    handleStatusSelect
                                                                }
                                                                selectedOption={
                                                                    trueSelectedStatus
                                                                }
                                                            />
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button
                                                                color="primary"
                                                                onClick={
                                                                    toggleTrueStatusModal
                                                                }
                                                            >
                                                                Done
                                                            </Button>
                                                        </ModalFooter>
                                                    </Modal>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueRecordCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={trueRecord}
                                                        disabled={
                                                            trueRecordDisabled
                                                        }
                                                        onClick={
                                                            handleTrueRecordCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Record
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueTakePhotoCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={trueTakePhoto}
                                                        disabled={
                                                            trueTakePhotoDisabled
                                                        }
                                                        onClick={
                                                            handleTrueTakePhotoCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Take Photo
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueTakeSignatureCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={
                                                            trueTakeSignature
                                                        }
                                                        disabled={
                                                            trueTakeSignatureDisabled
                                                        }
                                                        onClick={
                                                            handleTrueTakeSignatureCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Take Signature
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleTrueNoActionCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="true_log_checkbox"
                                                        checked={trueNoAction}
                                                        disabled={
                                                            trueNoActionDisabled
                                                        }
                                                        onClick={
                                                            handleTrueNoActionCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            No Action
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2">
                                        <div className="vl"></div>
                                    </div>

                                    <div className="col-md-5">
                                        <h3>False Action</h3>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseLogCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseLog}
                                                        disabled={
                                                            falseLogDisabled
                                                        }
                                                        onClick={
                                                            handleFalseLogCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Log
                                                        </b>
                                                    </label>
                                                </div>

                                                <div>
                                                    <Modal
                                                        isOpen={falseLogModal}
                                                    >
                                                        <ModalHeader>
                                                            False Action-Log:
                                                            Specify Options
                                                        </ModalHeader>
                                                        <ModalBody>
                                                            <h3>
                                                                Select Log Type
                                                            </h3>
                                                            <SelectList
                                                                options={
                                                                    falseLogList
                                                                }
                                                                actionHandler={
                                                                    falseHandleLogTypeSelect
                                                                }
                                                                selectedOption={
                                                                    falseLogSelectedType
                                                                }
                                                            />
                                                            <div
                                                                style={{
                                                                    marginTop: 50,
                                                                    height: 'auto',
                                                                }}
                                                            >
                                                                <h3>
                                                                    Enter Log
                                                                    Text
                                                                </h3>
                                                                <textarea
                                                                    type="text"
                                                                    className="form-control "
                                                                    placeholder="Enter Enter Log Text"
                                                                    id="f_log_text"
                                                                    value={
                                                                        falseLogText
                                                                    }
                                                                    onChange={
                                                                        handleFalseLogTextInput
                                                                    }
                                                                ></textarea>
                                                            </div>
                                                            <div
                                                                style={{
                                                                    marginTop: 50,
                                                                    height: 'auto',
                                                                }}
                                                            >
                                                                <h3>
                                                                    Log Options
                                                                    Checklist
                                                                </h3>
                                                                <div
                                                                    style={{
                                                                        marginLeft: 10,
                                                                        height: 'auto',
                                                                    }}
                                                                >
                                                                    <div className="row">
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="false_log_checkbox"
                                                                                checked={
                                                                                    falseLogDate
                                                                                }
                                                                                onClick={
                                                                                    handleFalseLogDateCheckboxClick
                                                                                }
                                                                                class="custom-checkbox"
                                                                            ></input>
                                                                            <b className="label-text">
                                                                                Date/Time
                                                                            </b>
                                                                        </label>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="false_log_checkbox"
                                                                                checked={
                                                                                    falseLogGPS
                                                                                }
                                                                                onClick={
                                                                                    handleFalseLogGPSCheckboxClick
                                                                                }
                                                                                class="custom-checkbox"
                                                                            ></input>
                                                                            <b className="label-text">
                                                                                GPS
                                                                                Cordinates
                                                                            </b>
                                                                        </label>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="false_log_checkbox"
                                                                                checked={
                                                                                    falseLogPackage
                                                                                }
                                                                                onClick={
                                                                                    handleFalseLogPackageCheckboxClick
                                                                                }
                                                                                class="custom-checkbox"
                                                                            ></input>
                                                                            <b className="label-text">
                                                                                No.
                                                                                of
                                                                                Packages
                                                                            </b>
                                                                        </label>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="false_log_checkbox"
                                                                                checked={
                                                                                    falseLogDriverName
                                                                                }
                                                                                onClick={
                                                                                    handleFalseLogDriverNameCheckboxClick
                                                                                }
                                                                                class="custom-checkbox"
                                                                            ></input>
                                                                            <b className="label-text">
                                                                                Driver
                                                                                Name
                                                                            </b>
                                                                        </label>
                                                                    </div>
                                                                    <div className="row">
                                                                        <label>
                                                                            <input
                                                                                type="checkbox"
                                                                                id="false_log_checkbox"
                                                                                checked={
                                                                                    falseLogCustomerName
                                                                                }
                                                                                onClick={
                                                                                    handleFalseLogCustomerNameCheckboxClick
                                                                                }
                                                                                class="custom-checkbox"
                                                                            ></input>
                                                                            <b className="label-text">
                                                                                Customer
                                                                                Name
                                                                            </b>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button
                                                                color="primary"
                                                                onClick={
                                                                    toggleFalseLogModal
                                                                }
                                                            >
                                                                Done
                                                            </Button>
                                                        </ModalFooter>
                                                    </Modal>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseBlockCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseBlock}
                                                        disabled={
                                                            falseBlockDisabled
                                                        }
                                                        onClick={
                                                            handleFalseBlockCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Block
                                                        </b>
                                                    </label>
                                                </div>
                                                <div>
                                                    <Modal
                                                        isOpen={falseBlockModal}
                                                    >
                                                        <ModalHeader>
                                                            <h3>
                                                                False
                                                                Action:Block
                                                                Text
                                                            </h3>
                                                        </ModalHeader>
                                                        <ModalBody>
                                                            <h3>
                                                                Enter Block Text
                                                            </h3>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                placeholder="Enter Block Text"
                                                                onChange={
                                                                    handleFalseBlockTextInput
                                                                }
                                                                value={
                                                                    falseBlockText
                                                                }
                                                                id="false_block_text_input"
                                                                maxLength={300}
                                                            ></input>
                                                        </ModalBody>
                                                        <ModalFooter>
                                                            <Button
                                                                color="primary"
                                                                onClick={
                                                                    toggleFalseBlockModal
                                                                }
                                                            >
                                                                Done
                                                            </Button>
                                                        </ModalFooter>
                                                    </Modal>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseStatusCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseStatus}
                                                        disabled={
                                                            falseStatusDisabled
                                                        }
                                                        onClick={
                                                            handleFalseStatusCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Status
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                            <div>
                                                <Modal
                                                    isOpen={falseStatusModal}
                                                >
                                                    <ModalHeader>
                                                        <h3>
                                                            False Action: Select
                                                            Status
                                                        </h3>
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <h3>
                                                            Select Status Type
                                                        </h3>
                                                        <SelectList
                                                            options={statusType}
                                                            actionHandler={
                                                                falseHandleStatusTypeSelect
                                                            }
                                                            selectedOption={
                                                                falseSelectedStatusType
                                                            }
                                                        />
                                                        <h3>
                                                            Select Status Code
                                                        </h3>
                                                        <SelectList
                                                            options={
                                                                falseStatusList
                                                            }
                                                            actionHandler={
                                                                falseHandleStatusSelect
                                                            }
                                                            selectedOption={
                                                                falseSelectedStatus
                                                            }
                                                        />
                                                    </ModalBody>
                                                    <ModalFooter>
                                                        <Button
                                                            color="primary"
                                                            onClick={
                                                                toggleFalseStatusModal
                                                            }
                                                        >
                                                            Done
                                                        </Button>
                                                    </ModalFooter>
                                                </Modal>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseRecordCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseRecord}
                                                        disabled={
                                                            falseRecordDisabled
                                                        }
                                                        onClick={
                                                            handleFalseRecordCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Record
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseTakePhotoCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseTakePhoto}
                                                        disabled={
                                                            falseTakePhotoDisabled
                                                        }
                                                        onClick={
                                                            handleFalseTakePhotoCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Take Photo
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseTakeSignatureCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={
                                                            falseTakeSignature
                                                        }
                                                        disabled={
                                                            falseTakeSignatureDisabled
                                                        }
                                                        onClick={
                                                            handleFalseTakeSignatureCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            Take Signature
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="row form">
                                            <div className="col-md-12">
                                                <div
                                                    class="inputGroup"
                                                    onClick={
                                                        handleFalseNoActionCheckboxClick
                                                    }
                                                >
                                                    <input
                                                        type="checkbox"
                                                        id="false_log_checkbox"
                                                        checked={falseNoAction}
                                                        onClick={
                                                            handleFalseNoActionCheckboxClick
                                                        }
                                                        class="custom-checkbox"
                                                    ></input>
                                                    <label>
                                                        <b className="label-text">
                                                            No Action
                                                        </b>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <button
                                            onClick={backSection4Btn}
                                            class="btn btn-blue-alt final_back_btn"
                                        >
                                            <b>Back</b>
                                        </button>
                                        <button
                                            class="btn btn-blue-alt final_next_btn"
                                            onClick={createQuestion}
                                        >
                                            <b>Create Question</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div></div>
            )}
            {currentSection === 5 ? (
                <div>
                    <Loader loading={loading} fullPage={true} />
                </div>
            ) : (
                <div></div>
            )}
        </div>
    )
}

export default CreateQuestionPageOne

/**
 * Notes
 * - True/false states??
 * - Im certain half of these can be burned
 * - Section 1: Section selection require double select for it to work due to js event loop
 * - Move each section into its own component? Might be easier to manage (But you do have to pass in props)
 */



// WEBPACK FOOTER //
// src/Routes/CreateQuestionP1.js